import _defineProperty from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _regeneratorRuntime from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _createForOfIteratorHelper from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _inherits from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import _wrapNativeSuper from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
import _classCallCheck from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import t, { useMemo as e, useContext as r, useReducer as n, useRef as o, useCallback as i, useEffect as s, createContext as c, useState as a } from "react";
import { ProvidedConnector as u, UserRejectedRequestError as l } from "@aragon/provided-connector";
import h, { EventEmitter as f } from "events";
var d = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};

function p() {
  throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
}

function _(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}

function g(t, e) {
  return t(e = {
    exports: {}
  }, e.exports), e.exports;
}

function m(t) {
  return t && t.default || t;
}
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */


var v = "function" == typeof Symbol && Symbol.for,
    y = v ? Symbol.for("react.element") : 60103,
    b = v ? Symbol.for("react.portal") : 60106,
    w = v ? Symbol.for("react.fragment") : 60107,
    E = v ? Symbol.for("react.strict_mode") : 60108,
    C = v ? Symbol.for("react.profiler") : 60114,
    O = v ? Symbol.for("react.provider") : 60109,
    P = v ? Symbol.for("react.context") : 60110,
    N = v ? Symbol.for("react.async_mode") : 60111,
    I = v ? Symbol.for("react.concurrent_mode") : 60111,
    D = v ? Symbol.for("react.forward_ref") : 60112,
    S = v ? Symbol.for("react.suspense") : 60113,
    R = v ? Symbol.for("react.suspense_list") : 60120,
    A = v ? Symbol.for("react.memo") : 60115,
    k = v ? Symbol.for("react.lazy") : 60116,
    T = v ? Symbol.for("react.block") : 60121,
    j = v ? Symbol.for("react.fundamental") : 60117,
    x = v ? Symbol.for("react.responder") : 60118,
    B = v ? Symbol.for("react.scope") : 60119;

function M(t) {
  if ("object" == typeof t && null !== t) {
    var e = t.$$typeof;

    switch (e) {
      case y:
        switch (t = t.type) {
          case N:
          case I:
          case w:
          case C:
          case E:
          case S:
            return t;

          default:
            switch (t = t && t.$$typeof) {
              case P:
              case D:
              case k:
              case A:
              case O:
                return t;

              default:
                return e;
            }

        }

      case b:
        return e;
    }
  }
}

function U(t) {
  return M(t) === I;
}

var L = {
  AsyncMode: N,
  ConcurrentMode: I,
  ContextConsumer: P,
  ContextProvider: O,
  Element: y,
  ForwardRef: D,
  Fragment: w,
  Lazy: k,
  Memo: A,
  Portal: b,
  Profiler: C,
  StrictMode: E,
  Suspense: S,
  isAsyncMode: function isAsyncMode(t) {
    return U(t) || M(t) === N;
  },
  isConcurrentMode: U,
  isContextConsumer: function isContextConsumer(t) {
    return M(t) === P;
  },
  isContextProvider: function isContextProvider(t) {
    return M(t) === O;
  },
  isElement: function isElement(t) {
    return "object" == typeof t && null !== t && t.$$typeof === y;
  },
  isForwardRef: function isForwardRef(t) {
    return M(t) === D;
  },
  isFragment: function isFragment(t) {
    return M(t) === w;
  },
  isLazy: function isLazy(t) {
    return M(t) === k;
  },
  isMemo: function isMemo(t) {
    return M(t) === A;
  },
  isPortal: function isPortal(t) {
    return M(t) === b;
  },
  isProfiler: function isProfiler(t) {
    return M(t) === C;
  },
  isStrictMode: function isStrictMode(t) {
    return M(t) === E;
  },
  isSuspense: function isSuspense(t) {
    return M(t) === S;
  },
  isValidElementType: function isValidElementType(t) {
    return "string" == typeof t || "function" == typeof t || t === w || t === I || t === C || t === E || t === S || t === R || "object" == typeof t && null !== t && (t.$$typeof === k || t.$$typeof === A || t.$$typeof === O || t.$$typeof === P || t.$$typeof === D || t.$$typeof === j || t.$$typeof === x || t.$$typeof === B || t.$$typeof === T);
  },
  typeOf: M
},
    V = g(function (t, e) {
  "production" !== process.env.NODE_ENV && function () {
    var t = "function" == typeof Symbol && Symbol.for,
        r = t ? Symbol.for("react.element") : 60103,
        n = t ? Symbol.for("react.portal") : 60106,
        o = t ? Symbol.for("react.fragment") : 60107,
        i = t ? Symbol.for("react.strict_mode") : 60108,
        s = t ? Symbol.for("react.profiler") : 60114,
        c = t ? Symbol.for("react.provider") : 60109,
        a = t ? Symbol.for("react.context") : 60110,
        u = t ? Symbol.for("react.async_mode") : 60111,
        l = t ? Symbol.for("react.concurrent_mode") : 60111,
        h = t ? Symbol.for("react.forward_ref") : 60112,
        f = t ? Symbol.for("react.suspense") : 60113,
        d = t ? Symbol.for("react.suspense_list") : 60120,
        p = t ? Symbol.for("react.memo") : 60115,
        _ = t ? Symbol.for("react.lazy") : 60116,
        g = t ? Symbol.for("react.block") : 60121,
        m = t ? Symbol.for("react.fundamental") : 60117,
        v = t ? Symbol.for("react.responder") : 60118,
        y = t ? Symbol.for("react.scope") : 60119;

    function b(t) {
      if ("object" == typeof t && null !== t) {
        var e = t.$$typeof;

        switch (e) {
          case r:
            var d = t.type;

            switch (d) {
              case u:
              case l:
              case o:
              case s:
              case i:
              case f:
                return d;

              default:
                var g = d && d.$$typeof;

                switch (g) {
                  case a:
                  case h:
                  case _:
                  case p:
                  case c:
                    return g;

                  default:
                    return e;
                }

            }

          case n:
            return e;
        }
      }
    }

    var w = u,
        E = l,
        C = a,
        O = c,
        P = r,
        N = h,
        I = o,
        D = _,
        S = p,
        R = n,
        A = s,
        k = i,
        T = f,
        j = !1;

    function x(t) {
      return b(t) === l;
    }

    e.AsyncMode = w, e.ConcurrentMode = E, e.ContextConsumer = C, e.ContextProvider = O, e.Element = P, e.ForwardRef = N, e.Fragment = I, e.Lazy = D, e.Memo = S, e.Portal = R, e.Profiler = A, e.StrictMode = k, e.Suspense = T, e.isAsyncMode = function (t) {
      return j || (j = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), x(t) || b(t) === u;
    }, e.isConcurrentMode = x, e.isContextConsumer = function (t) {
      return b(t) === a;
    }, e.isContextProvider = function (t) {
      return b(t) === c;
    }, e.isElement = function (t) {
      return "object" == typeof t && null !== t && t.$$typeof === r;
    }, e.isForwardRef = function (t) {
      return b(t) === h;
    }, e.isFragment = function (t) {
      return b(t) === o;
    }, e.isLazy = function (t) {
      return b(t) === _;
    }, e.isMemo = function (t) {
      return b(t) === p;
    }, e.isPortal = function (t) {
      return b(t) === n;
    }, e.isProfiler = function (t) {
      return b(t) === s;
    }, e.isStrictMode = function (t) {
      return b(t) === i;
    }, e.isSuspense = function (t) {
      return b(t) === f;
    }, e.isValidElementType = function (t) {
      return "string" == typeof t || "function" == typeof t || t === o || t === l || t === s || t === i || t === f || t === d || "object" == typeof t && null !== t && (t.$$typeof === _ || t.$$typeof === p || t.$$typeof === c || t.$$typeof === a || t.$$typeof === h || t.$$typeof === m || t.$$typeof === v || t.$$typeof === y || t.$$typeof === g);
    }, e.typeOf = b;
  }();
}),
    F = (V.AsyncMode, V.ConcurrentMode, V.ContextConsumer, V.ContextProvider, V.Element, V.ForwardRef, V.Fragment, V.Lazy, V.Memo, V.Portal, V.Profiler, V.StrictMode, V.Suspense, V.isAsyncMode, V.isConcurrentMode, V.isContextConsumer, V.isContextProvider, V.isElement, V.isForwardRef, V.isFragment, V.isLazy, V.isMemo, V.isPortal, V.isProfiler, V.isStrictMode, V.isSuspense, V.isValidElementType, V.typeOf, g(function (t) {
  "production" === process.env.NODE_ENV ? t.exports = L : t.exports = V;
})),
    q = Object.getOwnPropertySymbols,
    W = Object.prototype.hasOwnProperty,
    $ = Object.prototype.propertyIsEnumerable;

function z(t) {
  if (null == t) throw new TypeError("Object.assign cannot be called with null or undefined");
  return Object(t);
}

var G = function () {
  try {
    if (!Object.assign) return !1;
    var t = new String("abc");
    if (t[5] = "de", "5" === Object.getOwnPropertyNames(t)[0]) return !1;

    for (var e = {}, r = 0; r < 10; r++) {
      e["_" + String.fromCharCode(r)] = r;
    }

    if ("0123456789" !== Object.getOwnPropertyNames(e).map(function (t) {
      return e[t];
    }).join("")) return !1;
    var n = {};
    return "abcdefghijklmnopqrst".split("").forEach(function (t) {
      n[t] = t;
    }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, n)).join("");
  } catch (t) {
    return !1;
  }
}() ? Object.assign : function (t, e) {
  for (var r, n, o = z(t), i = 1; i < arguments.length; i++) {
    for (var s in r = Object(arguments[i])) {
      W.call(r, s) && (o[s] = r[s]);
    }

    if (q) {
      n = q(r);

      for (var c = 0; c < n.length; c++) {
        $.call(r, n[c]) && (o[n[c]] = r[n[c]]);
      }
    }
  }

  return o;
},
    H = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED",
    J = function J() {};

if ("production" !== process.env.NODE_ENV) {
  var K = H,
      X = {},
      Y = Function.call.bind(Object.prototype.hasOwnProperty);

  J = function J(t) {
    var e = "Warning: " + t;
    "undefined" != typeof console && console.error(e);

    try {
      throw new Error(e);
    } catch (t) {}
  };
}

function Q(t, e, r, n, o) {
  if ("production" !== process.env.NODE_ENV) for (var i in t) {
    if (Y(t, i)) {
      var s;

      try {
        if ("function" != typeof t[i]) {
          var c = Error((n || "React class") + ": " + r + " type `" + i + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[i] + "`.");
          throw c.name = "Invariant Violation", c;
        }

        s = t[i](e, i, n, r, null, K);
      } catch (t) {
        s = t;
      }

      if (!s || s instanceof Error || J((n || "React class") + ": type specification of " + r + " `" + i + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof s + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), s instanceof Error && !(s.message in X)) {
        X[s.message] = !0;
        var a = o ? o() : "";
        J("Failed " + r + " type: " + s.message + (null != a ? a : ""));
      }
    }
  }
}

Q.resetWarningCache = function () {
  "production" !== process.env.NODE_ENV && (X = {});
};

var Z = Q,
    tt = Function.call.bind(Object.prototype.hasOwnProperty),
    et = function et() {};

function rt() {
  return null;
}

"production" !== process.env.NODE_ENV && (et = function et(t) {
  var e = "Warning: " + t;
  "undefined" != typeof console && console.error(e);

  try {
    throw new Error(e);
  } catch (t) {}
});

var nt = function nt(t, e) {
  var r = "function" == typeof Symbol && Symbol.iterator;
  var n = {
    array: c("array"),
    bool: c("boolean"),
    func: c("function"),
    number: c("number"),
    object: c("object"),
    string: c("string"),
    symbol: c("symbol"),
    any: s(rt),
    arrayOf: function arrayOf(t) {
      return s(function (e, r, n, o, s) {
        if ("function" != typeof t) return new i("Property `" + s + "` of component `" + n + "` has invalid PropType notation inside arrayOf.");
        var c = e[r];
        if (!Array.isArray(c)) return new i("Invalid " + o + " `" + s + "` of type `" + u(c) + "` supplied to `" + n + "`, expected an array.");

        for (var a = 0; a < c.length; a++) {
          var l = t(c, a, n, o, s + "[" + a + "]", H);
          if (l instanceof Error) return l;
        }

        return null;
      });
    },
    element: s(function (e, r, n, o, s) {
      var c = e[r];
      return t(c) ? null : new i("Invalid " + o + " `" + s + "` of type `" + u(c) + "` supplied to `" + n + "`, expected a single ReactElement.");
    }),
    elementType: s(function (t, e, r, n, o) {
      var s = t[e];
      return F.isValidElementType(s) ? null : new i("Invalid " + n + " `" + o + "` of type `" + u(s) + "` supplied to `" + r + "`, expected a single ReactElement type.");
    }),
    instanceOf: function instanceOf(t) {
      return s(function (e, r, n, o, s) {
        if (!(e[r] instanceof t)) {
          var c = t.name || "<<anonymous>>";
          return new i("Invalid " + o + " `" + s + "` of type `" + function (t) {
            if (!t.constructor || !t.constructor.name) return "<<anonymous>>";
            return t.constructor.name;
          }(e[r]) + "` supplied to `" + n + "`, expected instance of `" + c + "`.");
        }

        return null;
      });
    },
    node: s(function (t, e, r, n, o) {
      return a(t[e]) ? null : new i("Invalid " + n + " `" + o + "` supplied to `" + r + "`, expected a ReactNode.");
    }),
    objectOf: function objectOf(t) {
      return s(function (e, r, n, o, s) {
        if ("function" != typeof t) return new i("Property `" + s + "` of component `" + n + "` has invalid PropType notation inside objectOf.");
        var c = e[r],
            a = u(c);
        if ("object" !== a) return new i("Invalid " + o + " `" + s + "` of type `" + a + "` supplied to `" + n + "`, expected an object.");

        for (var l in c) {
          if (tt(c, l)) {
            var h = t(c, l, n, o, s + "." + l, H);
            if (h instanceof Error) return h;
          }
        }

        return null;
      });
    },
    oneOf: function oneOf(t) {
      if (!Array.isArray(t)) return "production" !== process.env.NODE_ENV && (arguments.length > 1 ? et("Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).") : et("Invalid argument supplied to oneOf, expected an array.")), rt;

      function e(e, r, n, s, c) {
        for (var a = e[r], u = 0; u < t.length; u++) {
          if (o(a, t[u])) return null;
        }

        var h = JSON.stringify(t, function (t, e) {
          return "symbol" === l(e) ? String(e) : e;
        });
        return new i("Invalid " + s + " `" + c + "` of value `" + String(a) + "` supplied to `" + n + "`, expected one of " + h + ".");
      }

      return s(e);
    },
    oneOfType: function oneOfType(t) {
      if (!Array.isArray(t)) return "production" !== process.env.NODE_ENV && et("Invalid argument supplied to oneOfType, expected an instance of array."), rt;

      for (var e = 0; e < t.length; e++) {
        var r = t[e];
        if ("function" != typeof r) return et("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + h(r) + " at index " + e + "."), rt;
      }

      return s(function (e, r, n, o, s) {
        for (var c = 0; c < t.length; c++) {
          if (null == (0, t[c])(e, r, n, o, s, H)) return null;
        }

        return new i("Invalid " + o + " `" + s + "` supplied to `" + n + "`.");
      });
    },
    shape: function shape(t) {
      return s(function (e, r, n, o, s) {
        var c = e[r],
            a = u(c);
        if ("object" !== a) return new i("Invalid " + o + " `" + s + "` of type `" + a + "` supplied to `" + n + "`, expected `object`.");

        for (var l in t) {
          var h = t[l];

          if (h) {
            var f = h(c, l, n, o, s + "." + l, H);
            if (f) return f;
          }
        }

        return null;
      });
    },
    exact: function exact(t) {
      return s(function (e, r, n, o, s) {
        var c = e[r],
            a = u(c);
        if ("object" !== a) return new i("Invalid " + o + " `" + s + "` of type `" + a + "` supplied to `" + n + "`, expected `object`.");
        var l = G({}, e[r], t);

        for (var h in l) {
          var f = t[h];
          if (!f) return new i("Invalid " + o + " `" + s + "` key `" + h + "` supplied to `" + n + "`.\nBad object: " + JSON.stringify(e[r], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(t), null, "  "));
          var d = f(c, h, n, o, s + "." + h, H);
          if (d) return d;
        }

        return null;
      });
    }
  };

  function o(t, e) {
    return t === e ? 0 !== t || 1 / t == 1 / e : t != t && e != e;
  }

  function i(t) {
    this.message = t, this.stack = "";
  }

  function s(t) {
    if ("production" !== process.env.NODE_ENV) var r = {},
        n = 0;

    function o(o, s, c, a, u, l, h) {
      if (a = a || "<<anonymous>>", l = l || c, h !== H) {
        if (e) {
          var f = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
          throw f.name = "Invariant Violation", f;
        }

        if ("production" !== process.env.NODE_ENV && "undefined" != typeof console) {
          var d = a + ":" + c;
          !r[d] && n < 3 && (et("You are manually calling a React.PropTypes validation function for the `" + l + "` prop on `" + a + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), r[d] = !0, n++);
        }
      }

      return null == s[c] ? o ? null === s[c] ? new i("The " + u + " `" + l + "` is marked as required in `" + a + "`, but its value is `null`.") : new i("The " + u + " `" + l + "` is marked as required in `" + a + "`, but its value is `undefined`.") : null : t(s, c, a, u, l);
    }

    var s = o.bind(null, !1);
    return s.isRequired = o.bind(null, !0), s;
  }

  function c(t) {
    return s(function (e, r, n, o, s, c) {
      var a = e[r];
      return u(a) !== t ? new i("Invalid " + o + " `" + s + "` of type `" + l(a) + "` supplied to `" + n + "`, expected `" + t + "`.") : null;
    });
  }

  function a(e) {
    switch (typeof e) {
      case "number":
      case "string":
      case "undefined":
        return !0;

      case "boolean":
        return !e;

      case "object":
        if (Array.isArray(e)) return e.every(a);
        if (null === e || t(e)) return !0;

        var n = function (t) {
          var e = t && (r && t[r] || t["@@iterator"]);
          if ("function" == typeof e) return e;
        }(e);

        if (!n) return !1;
        var o,
            i = n.call(e);

        if (n !== e.entries) {
          for (; !(o = i.next()).done;) {
            if (!a(o.value)) return !1;
          }
        } else for (; !(o = i.next()).done;) {
          var s = o.value;
          if (s && !a(s[1])) return !1;
        }

        return !0;

      default:
        return !1;
    }
  }

  function u(t) {
    var e = typeof t;
    return Array.isArray(t) ? "array" : t instanceof RegExp ? "object" : function (t, e) {
      return "symbol" === t || !!e && ("Symbol" === e["@@toStringTag"] || "function" == typeof Symbol && e instanceof Symbol);
    }(e, t) ? "symbol" : e;
  }

  function l(t) {
    if (null == t) return "" + t;
    var e = u(t);

    if ("object" === e) {
      if (t instanceof Date) return "date";
      if (t instanceof RegExp) return "regexp";
    }

    return e;
  }

  function h(t) {
    var e = l(t);

    switch (e) {
      case "array":
      case "object":
        return "an " + e;

      case "boolean":
      case "date":
      case "regexp":
        return "a " + e;

      default:
        return e;
    }
  }

  return i.prototype = Error.prototype, n.checkPropTypes = Z, n.resetWarningCache = Z.resetWarningCache, n.PropTypes = n, n;
};

function ot() {}

function it() {}

it.resetWarningCache = ot;
var st,
    ct = g(function (t) {
  if ("production" !== process.env.NODE_ENV) {
    var e = F;
    t.exports = nt(e.isElement, !0);
  } else t.exports = function () {
    function t(t, e, r, n, o, i) {
      if (i !== H) {
        var s = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw s.name = "Invariant Violation", s;
      }
    }

    function e() {
      return t;
    }

    t.isRequired = t;
    var r = {
      array: t,
      bool: t,
      func: t,
      number: t,
      object: t,
      string: t,
      symbol: t,
      any: t,
      arrayOf: e,
      element: t,
      elementType: t,
      instanceOf: e,
      node: t,
      objectOf: e,
      oneOf: e,
      oneOfType: e,
      shape: e,
      exact: e,
      checkPropTypes: it,
      resetWarningCache: ot
    };
    return r.PropTypes = r, r;
  }();
}),
    at = "production" === process.env.NODE_ENV;

function ut(t, e) {
  if (!t) {
    if (at) throw new Error("Invariant failed");
    throw new Error("Invariant failed: " + (e || ""));
  }
}

!function (t) {
  t.Update = "Web3ReactUpdate", t.Error = "Web3ReactError", t.Deactivate = "Web3ReactDeactivate";
}(st || (st = {}));
var lt = "production" === process.env.NODE_ENV;

function ht(t, e) {
  if (!lt) {
    if (t) return;
    var r = "Warning: " + e;
    "undefined" != typeof console && console.warn(r);

    try {
      throw Error(r);
    } catch (t) {}
  }
}

var ft = !1,
    dt = !1;
var pt = {
  debug: 1,
  default: 2,
  info: 2,
  warning: 3,
  error: 4,
  off: 5
};
var _t = pt.default,
    gt = null;

var mt = function () {
  try {
    var _t2 = [];
    if (["NFD", "NFC", "NFKD", "NFKC"].forEach(function (e) {
      try {
        if ("test" !== "test".normalize(e)) throw new Error("bad normalize");
      } catch (r) {
        _t2.push(e);
      }
    }), _t2.length) throw new Error("missing " + _t2.join(", "));
    if (String.fromCharCode(233).normalize("NFD") !== String.fromCharCode(101, 769)) throw new Error("broken implementation");
  } catch (t) {
    return t.message;
  }

  return null;
}();

var vt = /*#__PURE__*/function () {
  function vt(t) {
    _classCallCheck(this, vt);

    Object.defineProperty(this, "version", {
      enumerable: !0,
      value: t,
      writable: !1
    });
  }

  _createClass(vt, [{
    key: "_log",
    value: function _log(t, e) {
      var r = t.toLowerCase();
      null == pt[r] && this.throwArgumentError("invalid log level name", "logLevel", t), _t > pt[r] || console.log.apply(console, e);
    }
  }, {
    key: "debug",
    value: function debug() {
      for (var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++) {
        t[_key] = arguments[_key];
      }

      this._log(vt.levels.DEBUG, t);
    }
  }, {
    key: "info",
    value: function info() {
      for (var _len2 = arguments.length, t = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        t[_key2] = arguments[_key2];
      }

      this._log(vt.levels.INFO, t);
    }
  }, {
    key: "warn",
    value: function warn() {
      for (var _len3 = arguments.length, t = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        t[_key3] = arguments[_key3];
      }

      this._log(vt.levels.WARNING, t);
    }
  }, {
    key: "makeError",
    value: function makeError(t, e, r) {
      if (dt) return this.makeError("censored error", e, {});
      e || (e = vt.errors.UNKNOWN_ERROR), r || (r = {});
      var n = [];
      Object.keys(r).forEach(function (t) {
        try {
          n.push(t + "=" + JSON.stringify(r[t]));
        } catch (e) {
          n.push(t + "=" + JSON.stringify(r[t].toString()));
        }
      }), n.push("code=".concat(e)), n.push("version=".concat(this.version));
      var o = t;
      n.length && (t += " (" + n.join(", ") + ")");
      var i = new Error(t);
      return i.reason = o, i.code = e, Object.keys(r).forEach(function (t) {
        i[t] = r[t];
      }), i;
    }
  }, {
    key: "throwError",
    value: function throwError(t, e, r) {
      throw this.makeError(t, e, r);
    }
  }, {
    key: "throwArgumentError",
    value: function throwArgumentError(t, e, r) {
      return this.throwError(t, vt.errors.INVALID_ARGUMENT, {
        argument: e,
        value: r
      });
    }
  }, {
    key: "checkNormalize",
    value: function checkNormalize(t) {
      mt && this.throwError("platform missing String.prototype.normalize", vt.errors.UNSUPPORTED_OPERATION, {
        operation: "String.prototype.normalize",
        form: mt
      });
    }
  }, {
    key: "checkSafeUint53",
    value: function checkSafeUint53(t, e) {
      "number" == typeof t && (null == e && (e = "value not safe"), (t < 0 || t >= 9007199254740991) && this.throwError(e, vt.errors.NUMERIC_FAULT, {
        operation: "checkSafeInteger",
        fault: "out-of-safe-range",
        value: t
      }), t % 1 && this.throwError(e, vt.errors.NUMERIC_FAULT, {
        operation: "checkSafeInteger",
        fault: "non-integer",
        value: t
      }));
    }
  }, {
    key: "checkArgumentCount",
    value: function checkArgumentCount(t, e, r) {
      r = r ? ": " + r : "", t < e && this.throwError("missing argument" + r, vt.errors.MISSING_ARGUMENT, {
        count: t,
        expectedCount: e
      }), t > e && this.throwError("too many arguments" + r, vt.errors.UNEXPECTED_ARGUMENT, {
        count: t,
        expectedCount: e
      });
    }
  }, {
    key: "checkNew",
    value: function checkNew(t, e) {
      t !== Object && null != t || this.throwError("missing new", vt.errors.MISSING_NEW, {
        name: e.name
      });
    }
  }, {
    key: "checkAbstract",
    value: function checkAbstract(t, e) {
      t === e ? this.throwError("cannot instantiate abstract class " + JSON.stringify(e.name) + " directly; use a sub-class", vt.errors.UNSUPPORTED_OPERATION, {
        name: t.name,
        operation: "new"
      }) : t !== Object && null != t || this.throwError("missing new", vt.errors.MISSING_NEW, {
        name: e.name
      });
    }
  }], [{
    key: "globalLogger",
    value: function globalLogger() {
      return gt || (gt = new vt("logger/5.0.0-beta.136")), gt;
    }
  }, {
    key: "setCensorship",
    value: function setCensorship(t, e) {
      if (!t && e && this.globalLogger().throwError("cannot permanently disable censorship", vt.errors.UNSUPPORTED_OPERATION, {
        operation: "setCensorship"
      }), ft) {
        if (!t) return;
        this.globalLogger().throwError("error censorship permanent", vt.errors.UNSUPPORTED_OPERATION, {
          operation: "setCensorship"
        });
      }

      dt = !!t, ft = !!e;
    }
  }, {
    key: "setLogLevel",
    value: function setLogLevel(t) {
      var e = pt[t];
      null != e ? _t = e : vt.globalLogger().warn("invalid log level - " + t);
    }
  }]);

  return vt;
}();

vt.errors = {
  UNKNOWN_ERROR: "UNKNOWN_ERROR",
  NOT_IMPLEMENTED: "NOT_IMPLEMENTED",
  UNSUPPORTED_OPERATION: "UNSUPPORTED_OPERATION",
  NETWORK_ERROR: "NETWORK_ERROR",
  SERVER_ERROR: "SERVER_ERROR",
  TIMEOUT: "TIMEOUT",
  BUFFER_OVERRUN: "BUFFER_OVERRUN",
  NUMERIC_FAULT: "NUMERIC_FAULT",
  MISSING_NEW: "MISSING_NEW",
  INVALID_ARGUMENT: "INVALID_ARGUMENT",
  MISSING_ARGUMENT: "MISSING_ARGUMENT",
  UNEXPECTED_ARGUMENT: "UNEXPECTED_ARGUMENT",
  CALL_EXCEPTION: "CALL_EXCEPTION",
  INSUFFICIENT_FUNDS: "INSUFFICIENT_FUNDS",
  NONCE_EXPIRED: "NONCE_EXPIRED",
  REPLACEMENT_UNDERPRICED: "REPLACEMENT_UNDERPRICED",
  UNPREDICTABLE_GAS_LIMIT: "UNPREDICTABLE_GAS_LIMIT"
}, vt.levels = {
  DEBUG: "DEBUG",
  INFO: "INFO",
  WARNING: "WARNING",
  ERROR: "ERROR",
  OFF: "OFF"
};
var yt = new vt("bytes/5.0.0-beta.137");

function bt(t) {
  return t.slice || (t.slice = function () {
    var e = Array.prototype.slice.call(arguments);
    return bt(new Uint8Array(Array.prototype.slice.apply(t, e)));
  }), t;
}

function wt(t, e) {
  if (e || (e = {}), "number" == typeof t) {
    yt.checkSafeUint53(t, "invalid arrayify value");
    var _e2 = [];

    for (; t;) {
      _e2.unshift(255 & t), t = parseInt(String(t / 256));
    }

    return 0 === _e2.length && _e2.push(0), bt(new Uint8Array(_e2));
  }

  if (e.allowMissingPrefix && "string" == typeof t && "0x" !== t.substring(0, 2) && (t = "0x" + t), function (t) {
    return !!t.toHexString;
  }(t) && (t = t.toHexString()), function (t, e) {
    if ("string" != typeof t || !t.match(/^0x[0-9A-Fa-f]*$/)) return !1;
    if (e && t.length !== 2 + 2 * e) return !1;
    return !0;
  }(t)) {
    var _r2 = t.substring(2);

    _r2.length % 2 && ("left" === e.hexPad ? _r2 = "0x0" + _r2.substring(2) : "right" === e.hexPad ? _r2 += "0" : yt.throwArgumentError("hex data is odd-length", "value", t));
    var _n = [];

    for (var _t3 = 0; _t3 < _r2.length; _t3 += 2) {
      _n.push(parseInt(_r2.substring(_t3, _t3 + 2), 16));
    }

    return bt(new Uint8Array(_n));
  }

  return function (t) {
    if (null == t) return !1;
    if (t.constructor === Uint8Array) return !0;
    if ("string" == typeof t) return !1;
    if (null == t.length) return !1;

    for (var _e3 = 0; _e3 < t.length; _e3++) {
      var _r3 = t[_e3];
      if (_r3 < 0 || _r3 >= 256 || _r3 % 1) return !1;
    }

    return !0;
  }(t) ? bt(new Uint8Array(t)) : yt.throwArgumentError("invalid arrayify value", "value", t);
}

var Et = g(function (t) {
  /**
   * [js-sha3]{@link https://github.com/emn178/js-sha3}
   *
   * @version 0.5.7
   * @author Chen, Yi-Cyuan [emn178@gmail.com]
   * @copyright Chen, Yi-Cyuan 2015-2016
   * @license MIT
   */
  !function () {
    var e = "object" == typeof window ? window : {};
    !e.JS_SHA3_NO_NODE_JS && "object" == typeof process && process.versions && process.versions.node && (e = d);

    for (var r = !e.JS_SHA3_NO_COMMON_JS && t.exports, n = "0123456789abcdef".split(""), o = [0, 8, 16, 24], i = [1, 0, 32898, 0, 32906, 2147483648, 2147516416, 2147483648, 32907, 0, 2147483649, 0, 2147516545, 2147483648, 32777, 2147483648, 138, 0, 136, 0, 2147516425, 0, 2147483658, 0, 2147516555, 0, 139, 2147483648, 32905, 2147483648, 32771, 2147483648, 32770, 2147483648, 128, 2147483648, 32778, 0, 2147483658, 2147483648, 2147516545, 2147483648, 32896, 2147483648, 2147483649, 0, 2147516424, 2147483648], s = [224, 256, 384, 512], c = ["hex", "buffer", "arrayBuffer", "array"], a = function a(t, e, r) {
      return function (n) {
        return new b(t, e, t).update(n)[r]();
      };
    }, u = function u(t, e, r) {
      return function (n, o) {
        return new b(t, e, o).update(n)[r]();
      };
    }, l = function l(t, e) {
      var r = a(t, e, "hex");
      r.create = function () {
        return new b(t, e, t);
      }, r.update = function (t) {
        return r.create().update(t);
      };

      for (var n = 0; n < c.length; ++n) {
        var o = c[n];
        r[o] = a(t, e, o);
      }

      return r;
    }, h = [{
      name: "keccak",
      padding: [1, 256, 65536, 16777216],
      bits: s,
      createMethod: l
    }, {
      name: "sha3",
      padding: [6, 1536, 393216, 100663296],
      bits: s,
      createMethod: l
    }, {
      name: "shake",
      padding: [31, 7936, 2031616, 520093696],
      bits: [128, 256],
      createMethod: function createMethod(t, e) {
        var r = u(t, e, "hex");
        r.create = function (r) {
          return new b(t, e, r);
        }, r.update = function (t, e) {
          return r.create(e).update(t);
        };

        for (var n = 0; n < c.length; ++n) {
          var o = c[n];
          r[o] = u(t, e, o);
        }

        return r;
      }
    }], f = {}, p = [], _ = 0; _ < h.length; ++_) {
      for (var g = h[_], m = g.bits, v = 0; v < m.length; ++v) {
        var y = g.name + "_" + m[v];
        p.push(y), f[y] = g.createMethod(m[v], g.padding);
      }
    }

    function b(t, e, r) {
      this.blocks = [], this.s = [], this.padding = e, this.outputBits = r, this.reset = !0, this.block = 0, this.start = 0, this.blockCount = 1600 - (t << 1) >> 5, this.byteCount = this.blockCount << 2, this.outputBlocks = r >> 5, this.extraBytes = (31 & r) >> 3;

      for (var n = 0; n < 50; ++n) {
        this.s[n] = 0;
      }
    }

    b.prototype.update = function (t) {
      var e = "string" != typeof t;
      e && t.constructor === ArrayBuffer && (t = new Uint8Array(t));

      for (var r, n, i = t.length, s = this.blocks, c = this.byteCount, a = this.blockCount, u = 0, l = this.s; u < i;) {
        if (this.reset) for (this.reset = !1, s[0] = this.block, r = 1; r < a + 1; ++r) {
          s[r] = 0;
        }
        if (e) for (r = this.start; u < i && r < c; ++u) {
          s[r >> 2] |= t[u] << o[3 & r++];
        } else for (r = this.start; u < i && r < c; ++u) {
          (n = t.charCodeAt(u)) < 128 ? s[r >> 2] |= n << o[3 & r++] : n < 2048 ? (s[r >> 2] |= (192 | n >> 6) << o[3 & r++], s[r >> 2] |= (128 | 63 & n) << o[3 & r++]) : n < 55296 || n >= 57344 ? (s[r >> 2] |= (224 | n >> 12) << o[3 & r++], s[r >> 2] |= (128 | n >> 6 & 63) << o[3 & r++], s[r >> 2] |= (128 | 63 & n) << o[3 & r++]) : (n = 65536 + ((1023 & n) << 10 | 1023 & t.charCodeAt(++u)), s[r >> 2] |= (240 | n >> 18) << o[3 & r++], s[r >> 2] |= (128 | n >> 12 & 63) << o[3 & r++], s[r >> 2] |= (128 | n >> 6 & 63) << o[3 & r++], s[r >> 2] |= (128 | 63 & n) << o[3 & r++]);
        }

        if (this.lastByteIndex = r, r >= c) {
          for (this.start = r - c, this.block = s[a], r = 0; r < a; ++r) {
            l[r] ^= s[r];
          }

          w(l), this.reset = !0;
        } else this.start = r;
      }

      return this;
    }, b.prototype.finalize = function () {
      var t = this.blocks,
          e = this.lastByteIndex,
          r = this.blockCount,
          n = this.s;
      if (t[e >> 2] |= this.padding[3 & e], this.lastByteIndex === this.byteCount) for (t[0] = t[r], e = 1; e < r + 1; ++e) {
        t[e] = 0;
      }

      for (t[r - 1] |= 2147483648, e = 0; e < r; ++e) {
        n[e] ^= t[e];
      }

      w(n);
    }, b.prototype.toString = b.prototype.hex = function () {
      this.finalize();

      for (var t, e = this.blockCount, r = this.s, o = this.outputBlocks, i = this.extraBytes, s = 0, c = 0, a = ""; c < o;) {
        for (s = 0; s < e && c < o; ++s, ++c) {
          t = r[s], a += n[t >> 4 & 15] + n[15 & t] + n[t >> 12 & 15] + n[t >> 8 & 15] + n[t >> 20 & 15] + n[t >> 16 & 15] + n[t >> 28 & 15] + n[t >> 24 & 15];
        }

        c % e == 0 && (w(r), s = 0);
      }

      return i && (t = r[s], i > 0 && (a += n[t >> 4 & 15] + n[15 & t]), i > 1 && (a += n[t >> 12 & 15] + n[t >> 8 & 15]), i > 2 && (a += n[t >> 20 & 15] + n[t >> 16 & 15])), a;
    }, b.prototype.arrayBuffer = function () {
      this.finalize();
      var t,
          e = this.blockCount,
          r = this.s,
          n = this.outputBlocks,
          o = this.extraBytes,
          i = 0,
          s = 0,
          c = this.outputBits >> 3;
      t = o ? new ArrayBuffer(n + 1 << 2) : new ArrayBuffer(c);

      for (var a = new Uint32Array(t); s < n;) {
        for (i = 0; i < e && s < n; ++i, ++s) {
          a[s] = r[i];
        }

        s % e == 0 && w(r);
      }

      return o && (a[i] = r[i], t = t.slice(0, c)), t;
    }, b.prototype.buffer = b.prototype.arrayBuffer, b.prototype.digest = b.prototype.array = function () {
      this.finalize();

      for (var t, e, r = this.blockCount, n = this.s, o = this.outputBlocks, i = this.extraBytes, s = 0, c = 0, a = []; c < o;) {
        for (s = 0; s < r && c < o; ++s, ++c) {
          t = c << 2, e = n[s], a[t] = 255 & e, a[t + 1] = e >> 8 & 255, a[t + 2] = e >> 16 & 255, a[t + 3] = e >> 24 & 255;
        }

        c % r == 0 && w(n);
      }

      return i && (t = c << 2, e = n[s], i > 0 && (a[t] = 255 & e), i > 1 && (a[t + 1] = e >> 8 & 255), i > 2 && (a[t + 2] = e >> 16 & 255)), a;
    };

    var w = function w(t) {
      var e, r, n, o, s, c, a, u, l, h, f, d, p, _, g, m, v, y, b, w, E, C, O, P, N, I, D, S, R, A, k, T, j, x, B, M, U, L, V, F, q, W, $, z, G, H, J, K, X, Y, Q, Z, tt, et, rt, nt, ot, it, st, ct, at, ut, lt;

      for (n = 0; n < 48; n += 2) {
        o = t[0] ^ t[10] ^ t[20] ^ t[30] ^ t[40], s = t[1] ^ t[11] ^ t[21] ^ t[31] ^ t[41], c = t[2] ^ t[12] ^ t[22] ^ t[32] ^ t[42], a = t[3] ^ t[13] ^ t[23] ^ t[33] ^ t[43], u = t[4] ^ t[14] ^ t[24] ^ t[34] ^ t[44], l = t[5] ^ t[15] ^ t[25] ^ t[35] ^ t[45], h = t[6] ^ t[16] ^ t[26] ^ t[36] ^ t[46], f = t[7] ^ t[17] ^ t[27] ^ t[37] ^ t[47], e = (d = t[8] ^ t[18] ^ t[28] ^ t[38] ^ t[48]) ^ (c << 1 | a >>> 31), r = (p = t[9] ^ t[19] ^ t[29] ^ t[39] ^ t[49]) ^ (a << 1 | c >>> 31), t[0] ^= e, t[1] ^= r, t[10] ^= e, t[11] ^= r, t[20] ^= e, t[21] ^= r, t[30] ^= e, t[31] ^= r, t[40] ^= e, t[41] ^= r, e = o ^ (u << 1 | l >>> 31), r = s ^ (l << 1 | u >>> 31), t[2] ^= e, t[3] ^= r, t[12] ^= e, t[13] ^= r, t[22] ^= e, t[23] ^= r, t[32] ^= e, t[33] ^= r, t[42] ^= e, t[43] ^= r, e = c ^ (h << 1 | f >>> 31), r = a ^ (f << 1 | h >>> 31), t[4] ^= e, t[5] ^= r, t[14] ^= e, t[15] ^= r, t[24] ^= e, t[25] ^= r, t[34] ^= e, t[35] ^= r, t[44] ^= e, t[45] ^= r, e = u ^ (d << 1 | p >>> 31), r = l ^ (p << 1 | d >>> 31), t[6] ^= e, t[7] ^= r, t[16] ^= e, t[17] ^= r, t[26] ^= e, t[27] ^= r, t[36] ^= e, t[37] ^= r, t[46] ^= e, t[47] ^= r, e = h ^ (o << 1 | s >>> 31), r = f ^ (s << 1 | o >>> 31), t[8] ^= e, t[9] ^= r, t[18] ^= e, t[19] ^= r, t[28] ^= e, t[29] ^= r, t[38] ^= e, t[39] ^= r, t[48] ^= e, t[49] ^= r, _ = t[0], g = t[1], H = t[11] << 4 | t[10] >>> 28, J = t[10] << 4 | t[11] >>> 28, S = t[20] << 3 | t[21] >>> 29, R = t[21] << 3 | t[20] >>> 29, ct = t[31] << 9 | t[30] >>> 23, at = t[30] << 9 | t[31] >>> 23, W = t[40] << 18 | t[41] >>> 14, $ = t[41] << 18 | t[40] >>> 14, x = t[2] << 1 | t[3] >>> 31, B = t[3] << 1 | t[2] >>> 31, m = t[13] << 12 | t[12] >>> 20, v = t[12] << 12 | t[13] >>> 20, K = t[22] << 10 | t[23] >>> 22, X = t[23] << 10 | t[22] >>> 22, A = t[33] << 13 | t[32] >>> 19, k = t[32] << 13 | t[33] >>> 19, ut = t[42] << 2 | t[43] >>> 30, lt = t[43] << 2 | t[42] >>> 30, et = t[5] << 30 | t[4] >>> 2, rt = t[4] << 30 | t[5] >>> 2, M = t[14] << 6 | t[15] >>> 26, U = t[15] << 6 | t[14] >>> 26, y = t[25] << 11 | t[24] >>> 21, b = t[24] << 11 | t[25] >>> 21, Y = t[34] << 15 | t[35] >>> 17, Q = t[35] << 15 | t[34] >>> 17, T = t[45] << 29 | t[44] >>> 3, j = t[44] << 29 | t[45] >>> 3, P = t[6] << 28 | t[7] >>> 4, N = t[7] << 28 | t[6] >>> 4, nt = t[17] << 23 | t[16] >>> 9, ot = t[16] << 23 | t[17] >>> 9, L = t[26] << 25 | t[27] >>> 7, V = t[27] << 25 | t[26] >>> 7, w = t[36] << 21 | t[37] >>> 11, E = t[37] << 21 | t[36] >>> 11, Z = t[47] << 24 | t[46] >>> 8, tt = t[46] << 24 | t[47] >>> 8, z = t[8] << 27 | t[9] >>> 5, G = t[9] << 27 | t[8] >>> 5, I = t[18] << 20 | t[19] >>> 12, D = t[19] << 20 | t[18] >>> 12, it = t[29] << 7 | t[28] >>> 25, st = t[28] << 7 | t[29] >>> 25, F = t[38] << 8 | t[39] >>> 24, q = t[39] << 8 | t[38] >>> 24, C = t[48] << 14 | t[49] >>> 18, O = t[49] << 14 | t[48] >>> 18, t[0] = _ ^ ~m & y, t[1] = g ^ ~v & b, t[10] = P ^ ~I & S, t[11] = N ^ ~D & R, t[20] = x ^ ~M & L, t[21] = B ^ ~U & V, t[30] = z ^ ~H & K, t[31] = G ^ ~J & X, t[40] = et ^ ~nt & it, t[41] = rt ^ ~ot & st, t[2] = m ^ ~y & w, t[3] = v ^ ~b & E, t[12] = I ^ ~S & A, t[13] = D ^ ~R & k, t[22] = M ^ ~L & F, t[23] = U ^ ~V & q, t[32] = H ^ ~K & Y, t[33] = J ^ ~X & Q, t[42] = nt ^ ~it & ct, t[43] = ot ^ ~st & at, t[4] = y ^ ~w & C, t[5] = b ^ ~E & O, t[14] = S ^ ~A & T, t[15] = R ^ ~k & j, t[24] = L ^ ~F & W, t[25] = V ^ ~q & $, t[34] = K ^ ~Y & Z, t[35] = X ^ ~Q & tt, t[44] = it ^ ~ct & ut, t[45] = st ^ ~at & lt, t[6] = w ^ ~C & _, t[7] = E ^ ~O & g, t[16] = A ^ ~T & P, t[17] = k ^ ~j & N, t[26] = F ^ ~W & x, t[27] = q ^ ~$ & B, t[36] = Y ^ ~Z & z, t[37] = Q ^ ~tt & G, t[46] = ct ^ ~ut & et, t[47] = at ^ ~lt & rt, t[8] = C ^ ~_ & m, t[9] = O ^ ~g & v, t[18] = T ^ ~P & I, t[19] = j ^ ~N & D, t[28] = W ^ ~x & M, t[29] = $ ^ ~B & U, t[38] = Z ^ ~z & H, t[39] = tt ^ ~G & J, t[48] = ut ^ ~et & nt, t[49] = lt ^ ~rt & ot, t[0] ^= i[n], t[1] ^= i[n + 1];
      }
    };

    if (r) t.exports = f;else for (_ = 0; _ < p.length; ++_) {
      e[p[_]] = f[p[_]];
    }
  }();
});

function Ct() {
  return (Ct = Object.assign || function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];

      for (var n in r) {
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
      }
    }

    return t;
  }).apply(this, arguments);
}

function Ot(t, e) {
  t.prototype = Object.create(e.prototype), t.prototype.constructor = t, t.__proto__ = e;
}

function Pt(t) {
  return (Pt = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  })(t);
}

function Nt(t, e) {
  return (Nt = Object.setPrototypeOf || function (t, e) {
    return t.__proto__ = e, t;
  })(t, e);
}

function It() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (t) {
    return !1;
  }
}

function Dt(t, e, r) {
  return (Dt = It() ? Reflect.construct : function (t, e, r) {
    var n = [null];
    n.push.apply(n, e);
    var o = new (Function.bind.apply(t, n))();
    return r && Nt(o, r.prototype), o;
  }).apply(null, arguments);
}

function St(t) {
  var e = "function" == typeof Map ? new Map() : void 0;
  return (St = function St(t) {
    if (null === t || (r = t, -1 === Function.toString.call(r).indexOf("[native code]"))) return t;
    var r;
    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");

    if (void 0 !== e) {
      if (e.has(t)) return e.get(t);
      e.set(t, n);
    }

    function n() {
      return Dt(t, arguments, Pt(this).constructor);
    }

    return n.prototype = Object.create(t.prototype, {
      constructor: {
        value: n,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), Nt(n, t);
  })(t);
}

"undefined" != typeof Symbol && (Symbol.iterator || (Symbol.iterator = Symbol("Symbol.iterator"))), "undefined" != typeof Symbol && (Symbol.asyncIterator || (Symbol.asyncIterator = Symbol("Symbol.asyncIterator")));

function Rt(t, e) {
  try {
    var r = t();
  } catch (t) {
    return e(t);
  }

  return r && r.then ? r.then(void 0, e) : r;
}

function At(t) {
  if ("string" == typeof t) {
    t = t.replace(/^Ox/, "0x");
    var e = Number.parseInt(t, "0x" === t.trim().substring(0, 2) ? 16 : 10);
    return Number.isNaN(e) && ("production" !== process.env.NODE_ENV ? ut(!1, "chainId " + t + " is not an integer") : ut(!1)), e;
  }

  return Number.isInteger(t) || ("production" !== process.env.NODE_ENV ? ut(!1, "chainId " + t + " is not an integer") : ut(!1)), t;
}

function kt(t) {
  "string" == typeof t && t.match(/^(0x)?[0-9a-fA-F]{40}$/) || ("production" !== process.env.NODE_ENV ? ut(!1, "Invalid address " + t) : ut(!1));

  for (var e = "0x" === t.substring(0, 2) ? t : "0x" + t, r = e.toLowerCase().substring(2).split(""), n = new Uint8Array(40), o = 0; o < 40; o++) {
    n[o] = r[o].charCodeAt(0);
  }

  for (var i, s = wt((i = n, "0x" + Et.keccak_256(wt(i)))), c = 0; c < 40; c += 2) {
    s[c >> 1] >> 4 >= 8 && (r[c] = r[c].toUpperCase()), (15 & s[c >> 1]) >= 8 && (r[c + 1] = r[c + 1].toUpperCase());
  }

  var a = "0x" + r.join("");
  return e.match(/([A-F].*[a-f])|([a-f].*[A-F])/) && e !== a && ("production" !== process.env.NODE_ENV ? ut(!1, "Bad address checksum " + e + " " + a) : ut(!1)), a;
}

var Tt,
    jt = function jt(t, e) {
  try {
    var r = function r(_r4) {
      return Promise.resolve(Promise.all([void 0 === e.chainId ? t.getChainId() : e.chainId, void 0 === e.account ? t.getAccount() : e.account])).then(function (e) {
        var n = e[0],
            o = e[1],
            i = At(n);
        if (t.supportedChainIds && !t.supportedChainIds.includes(i)) throw new Bt(i, t.supportedChainIds);
        var s = null === o ? o : kt(o);
        return {
          provider: _r4,
          chainId: i,
          account: s
        };
      });
    },
        n = void 0 === e.provider;

    return Promise.resolve(n ? Promise.resolve(t.getProvider()).then(r) : r(e.provider));
  } catch (t) {
    return Promise.reject(t);
  }
},
    xt = function (t) {
  function e() {
    var e;
    return (e = t.call(this) || this).name = e.constructor.name, e;
  }

  return Ot(e, t), e;
}(St(Error)),
    Bt = function (t) {
  function e(e, r) {
    var n;
    return (n = t.call(this) || this).name = n.constructor.name, n.message = "Unsupported chain id: " + e + ". Supported chain ids are: " + r + ".", n;
  }

  return Ot(e, t), e;
}(St(Error));

function Mt(t, e) {
  var r = e.type,
      n = e.payload;

  switch (r) {
    case Tt.ACTIVATE_CONNECTOR:
      return {
        connector: n.connector,
        provider: n.provider,
        chainId: n.chainId,
        account: n.account,
        onError: n.onError
      };

    case Tt.UPDATE:
      var o = n.provider,
          i = n.chainId,
          s = n.account;
      return Ct({}, t, void 0 === o ? {} : {
        provider: o
      }, void 0 === i ? {} : {
        chainId: i
      }, void 0 === s ? {} : {
        account: s
      });

    case Tt.UPDATE_FROM_ERROR:
      var c = n.provider,
          a = n.chainId,
          u = n.account;
      return Ct({}, t, void 0 === c ? {} : {
        provider: c
      }, void 0 === a ? {} : {
        chainId: a
      }, void 0 === u ? {} : {
        account: u
      }, {
        error: void 0
      });

    case Tt.ERROR:
      var l = n.error;
      return {
        connector: t.connector,
        error: l,
        onError: t.onError
      };

    case Tt.ERROR_FROM_ACTIVATION:
      return {
        connector: n.connector,
        error: n.error
      };

    case Tt.DEACTIVATE_CONNECTOR:
      return {};
  }
}

!function (t) {
  t[t.ACTIVATE_CONNECTOR = 0] = "ACTIVATE_CONNECTOR", t[t.UPDATE = 1] = "UPDATE", t[t.UPDATE_FROM_ERROR = 2] = "UPDATE_FROM_ERROR", t[t.ERROR = 3] = "ERROR", t[t.ERROR_FROM_ACTIVATION = 4] = "ERROR_FROM_ACTIVATION", t[t.DEACTIVATE_CONNECTOR = 5] = "DEACTIVATE_CONNECTOR";
}(Tt || (Tt = {}));
var Ut = {};

function Lt(r) {
  Ut[r] && ("production" !== process.env.NODE_ENV ? ut(!1, "A root already exists for provided key " + r) : ut(!1)), Ut[r] = c({
    activate: function activate() {
      try {
        return "production" !== process.env.NODE_ENV ? ut(!1, "No <Web3ReactProvider ... /> found.") : ut(!1), Promise.resolve();
      } catch (t) {
        return Promise.reject(t);
      }
    },
    setError: function setError() {
      "production" !== process.env.NODE_ENV ? ut(!1, "No <Web3ReactProvider ... /> found.") : ut(!1);
    },
    deactivate: function deactivate() {
      "production" !== process.env.NODE_ENV ? ut(!1, "No <Web3ReactProvider ... /> found.") : ut(!1);
    },
    active: !1
  }), Ut[r].displayName = "Web3ReactContext - " + r;
  var a = Ut[r].Provider;
  return function (r) {
    var c = r.getLibrary,
        u = r.children,
        l = function () {
      var t = n(Mt, {}),
          e = t[0],
          r = t[1],
          c = e.connector,
          a = e.provider,
          u = e.chainId,
          l = e.account,
          h = e.onError,
          f = e.error,
          d = o(-1);
      d.current += 1;

      var p = i(function (t, e, n) {
        void 0 === n && (n = !1);

        try {
          var o = d.current,
              i = !1;
          return Promise.resolve(Rt(function () {
            return Promise.resolve(t.activate().then(function (t) {
              return i = !0, t;
            })).then(function (n) {
              return Promise.resolve(jt(t, n)).then(function (n) {
                if (d.current > o) throw new xt();
                r({
                  type: Tt.ACTIVATE_CONNECTOR,
                  payload: Ct({
                    connector: t
                  }, n, {
                    onError: e
                  })
                });
              });
            });
          }, function (o) {
            if (o instanceof xt) i && t.deactivate(), "production" !== process.env.NODE_ENV && ht(!1, "Suppressed stale connector activation " + t);else {
              if (n) throw i && t.deactivate(), o;
              e ? (i && t.deactivate(), e(o)) : r({
                type: Tt.ERROR_FROM_ACTIVATION,
                payload: {
                  connector: t,
                  error: o
                }
              });
            }
          }));
        } catch (t) {
          return Promise.reject(t);
        }
      }, []),
          _ = i(function (t) {
        r({
          type: Tt.ERROR,
          payload: {
            error: t
          }
        });
      }, []),
          g = i(function () {
        r({
          type: Tt.DEACTIVATE_CONNECTOR
        });
      }, []),
          m = i(function (t) {
        try {
          if (!c) throw Error("This should never happen, it's just so Typescript stops complaining");
          var e = d.current;
          return Promise.resolve(function () {
            if (f) return Rt(function () {
              return Promise.resolve(jt(c, t)).then(function (t) {
                if (d.current > e) throw new xt();
                r({
                  type: Tt.UPDATE_FROM_ERROR,
                  payload: t
                });
              });
            }, function (e) {
              e instanceof xt ? "production" !== process.env.NODE_ENV && ht(!1, "Suppressed stale connector update from error state " + c + " " + t) : h ? h(e) : r({
                type: Tt.ERROR,
                payload: {
                  error: e
                }
              });
            });
            var n = void 0 === t.chainId ? void 0 : At(t.chainId);

            if (void 0 !== n && c.supportedChainIds && !c.supportedChainIds.includes(n)) {
              var o = new Bt(n, c.supportedChainIds);
              h ? h(o) : r({
                type: Tt.ERROR,
                payload: {
                  error: o
                }
              });
            } else {
              var i = "string" == typeof t.account ? kt(t.account) : t.account;
              r({
                type: Tt.UPDATE,
                payload: {
                  provider: t.provider,
                  chainId: n,
                  account: i
                }
              });
            }
          }());
        } catch (t) {
          return Promise.reject(t);
        }
      }, [c, f, h]),
          v = i(function (t) {
        h ? h(t) : r({
          type: Tt.ERROR,
          payload: {
            error: t
          }
        });
      }, [h]),
          y = i(function () {
        r({
          type: Tt.DEACTIVATE_CONNECTOR
        });
      }, []);

      return s(function () {
        return function () {
          c && c.deactivate();
        };
      }, [c]), s(function () {
        return c && c.on(st.Update, m).on(st.Error, v).on(st.Deactivate, y), function () {
          c && c.off(st.Update, m).off(st.Error, v).off(st.Deactivate, y);
        };
      }, [c, m, v, y]), {
        connector: c,
        provider: a,
        chainId: u,
        account: l,
        activate: p,
        setError: _,
        deactivate: g,
        error: f
      };
    }(),
        h = l.connector,
        f = l.provider,
        d = l.chainId,
        p = l.account,
        _ = l.activate,
        g = l.setError,
        m = l.deactivate,
        v = l.error,
        y = void 0 !== h && void 0 !== d && void 0 !== p && !v,
        b = e(function () {
      return y && void 0 !== d && Number.isInteger(d) && h ? c(f, h) : void 0;
    }, [y, c, f, h, d]),
        w = {
      connector: h,
      library: b,
      chainId: d,
      account: p,
      activate: _,
      setError: g,
      deactivate: m,
      active: y,
      error: v
    };

    return t.createElement(a, {
      value: w
    }, u);
  };
}

var Vt = Lt("primary");

function Ft(t) {
  return r(function (t) {
    return void 0 === t && (t = "primary"), Object.keys(Ut).includes(t) || ("production" !== process.env.NODE_ENV ? ut(!1, "Invalid key " + t) : ut(!1)), Ut[t];
  }(t));
}

var qt = /*#__PURE__*/function (_Array) {
  _inherits(qt, _Array);

  var _super = _createSuper(qt);

  function qt(t, e) {
    var _this;

    _classCallCheck(this, qt);

    if (t > qt.__kMaxLength) throw new RangeError("Maximum BigInt size exceeded");
    _this = _super.call(this, t), _this.sign = e;
    return _this;
  }

  _createClass(qt, [{
    key: "toDebugString",
    value: function toDebugString() {
      var t = ["BigInt["];

      var _iterator = _createForOfIteratorHelper(this),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _e4 = _step.value;
          t.push((_e4 ? (_e4 >>> 0).toString(16) : _e4) + ", ");
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return t.push("]"), t.join("");
    }
  }, {
    key: "toString",
    value: function toString() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
      if (2 > t || 36 < t) throw new RangeError("toString() radix argument must be between 2 and 36");
      return 0 === this.length ? "0" : 0 == (t & t - 1) ? qt.__toStringBasePowerOfTwo(this, t) : qt.__toStringGeneric(this, t, !1);
    }
  }, {
    key: "__copy",
    value: function __copy() {
      var t = new qt(this.length, this.sign);

      for (var _e5 = 0; _e5 < this.length; _e5++) {
        t[_e5] = this[_e5];
      }

      return t;
    }
  }, {
    key: "__trim",
    value: function __trim() {
      var t = this.length,
          e = this[t - 1];

      for (; 0 === e;) {
        t--, e = this[t - 1], this.pop();
      }

      return 0 === t && (this.sign = !1), this;
    }
  }, {
    key: "__initializeDigits",
    value: function __initializeDigits() {
      for (var _t4 = 0; _t4 < this.length; _t4++) {
        this[_t4] = 0;
      }
    }
  }, {
    key: "__clzmsd",
    value: function __clzmsd() {
      return Math.clz32(this[this.length - 1]);
    }
  }, {
    key: "__inplaceMultiplyAdd",
    value: function __inplaceMultiplyAdd(t, e, r) {
      var n = Math.imul;
      r > this.length && (r = this.length);
      var o = 65535 & t,
          i = t >>> 16;
      var s = 0,
          c = 65535 & e,
          a = e >>> 16;

      for (var _t5 = 0; _t5 < r; _t5++) {
        var _e6 = this.__digit(_t5),
            _r5 = 65535 & _e6,
            _u = _e6 >>> 16,
            _l = n(_r5, o),
            _h = n(_r5, i),
            _f = n(_u, o),
            _d = n(_u, i),
            _p = c + (65535 & _l),
            _2 = a + s + (_p >>> 16) + (_l >>> 16) + (65535 & _h) + (65535 & _f);

        c = (_h >>> 16) + (_f >>> 16) + (65535 & _d) + (_2 >>> 16), s = c >>> 16, c &= 65535, a = _d >>> 16, this.__setDigit(_t5, 65535 & _p | _2 << 16);
      }

      if (0 != s || 0 !== c || 0 !== a) throw new Error("implementation bug");
    }
  }, {
    key: "__inplaceAdd",
    value: function __inplaceAdd(t, e, r) {
      var n = 0;

      for (var _o = 0; _o < r; _o++) {
        var _r6 = this.__halfDigit(e + _o) + t.__halfDigit(_o) + n;

        n = _r6 >>> 16, this.__setHalfDigit(e + _o, _r6);
      }

      return n;
    }
  }, {
    key: "__inplaceSub",
    value: function __inplaceSub(t, e, r) {
      var n = 0;

      if (1 & e) {
        e >>= 1;

        var _o2 = this.__digit(e),
            _i = 65535 & _o2,
            _s = 0;

        for (; _s < r - 1 >>> 1; _s++) {
          var _r7 = t.__digit(_s),
              _c2 = (_o2 >>> 16) - (65535 & _r7) - n;

          n = 1 & _c2 >>> 16, this.__setDigit(e + _s, _c2 << 16 | 65535 & _i), _o2 = this.__digit(e + _s + 1), _i = (65535 & _o2) - (_r7 >>> 16) - n, n = 1 & _i >>> 16;
        }

        var _c = t.__digit(_s),
            _a = (_o2 >>> 16) - (65535 & _c) - n;

        if (n = 1 & _a >>> 16, this.__setDigit(e + _s, _a << 16 | 65535 & _i), e + _s + 1 >= this.length) throw new RangeError("out of bounds");
        0 == (1 & r) && (_o2 = this.__digit(e + _s + 1), _i = (65535 & _o2) - (_c >>> 16) - n, n = 1 & _i >>> 16, this.__setDigit(e + t.length, 4294901760 & _o2 | 65535 & _i));
      } else {
        e >>= 1;
        var _o3 = 0;

        for (; _o3 < t.length - 1; _o3++) {
          var _r8 = this.__digit(e + _o3),
              _i3 = t.__digit(_o3),
              _s3 = (65535 & _r8) - (65535 & _i3) - n;

          n = 1 & _s3 >>> 16;

          var _c4 = (_r8 >>> 16) - (_i3 >>> 16) - n;

          n = 1 & _c4 >>> 16, this.__setDigit(e + _o3, _c4 << 16 | 65535 & _s3);
        }

        var _i2 = this.__digit(e + _o3),
            _s2 = t.__digit(_o3),
            _c3 = (65535 & _i2) - (65535 & _s2) - n;

        n = 1 & _c3 >>> 16;
        var _a2 = 0;
        0 == (1 & r) && (_a2 = (_i2 >>> 16) - (_s2 >>> 16) - n, n = 1 & _a2 >>> 16), this.__setDigit(e + _o3, _a2 << 16 | 65535 & _c3);
      }

      return n;
    }
  }, {
    key: "__inplaceRightShift",
    value: function __inplaceRightShift(t) {
      if (0 === t) return;
      var e = this.__digit(0) >>> t;
      var r = this.length - 1;

      for (var _n2 = 0; _n2 < r; _n2++) {
        var _r9 = this.__digit(_n2 + 1);

        this.__setDigit(_n2, _r9 << 32 - t | e), e = _r9 >>> t;
      }

      this.__setDigit(r, e);
    }
  }, {
    key: "__digit",
    value: function __digit(t) {
      return this[t];
    }
  }, {
    key: "__unsignedDigit",
    value: function __unsignedDigit(t) {
      return this[t] >>> 0;
    }
  }, {
    key: "__setDigit",
    value: function __setDigit(t, e) {
      this[t] = 0 | e;
    }
  }, {
    key: "__setDigitGrow",
    value: function __setDigitGrow(t, e) {
      this[t] = 0 | e;
    }
  }, {
    key: "__halfDigitLength",
    value: function __halfDigitLength() {
      var t = this.length;
      return 65535 >= this.__unsignedDigit(t - 1) ? 2 * t - 1 : 2 * t;
    }
  }, {
    key: "__halfDigit",
    value: function __halfDigit(t) {
      return 65535 & this[t >>> 1] >>> ((1 & t) << 4);
    }
  }, {
    key: "__setHalfDigit",
    value: function __setHalfDigit(t, e) {
      var r = t >>> 1,
          n = this.__digit(r),
          o = 1 & t ? 65535 & n | e << 16 : 4294901760 & n | 65535 & e;

      this.__setDigit(r, o);
    }
  }], [{
    key: "BigInt",
    value: function BigInt(t) {
      var e = Math.floor,
          r = Number.isFinite;

      if ("number" == typeof t) {
        if (0 === t) return qt.__zero();
        if ((0 | t) === t) return 0 > t ? qt.__oneDigit(-t, !0) : qt.__oneDigit(t, !1);
        if (!r(t) || e(t) !== t) throw new RangeError("The number " + t + " cannot be converted to BigInt because it is not an integer");
        return qt.__fromDouble(t);
      }

      if ("string" == typeof t) {
        var _e7 = qt.__fromString(t);

        if (null === _e7) throw new SyntaxError("Cannot convert " + t + " to a BigInt");
        return _e7;
      }

      if ("boolean" == typeof t) return !0 === t ? qt.__oneDigit(1, !1) : qt.__zero();

      if ("object" == typeof t) {
        if (t.constructor === qt) return t;

        var _e8 = qt.__toPrimitive(t);

        return qt.BigInt(_e8);
      }

      throw new TypeError("Cannot convert " + t + " to a BigInt");
    }
  }, {
    key: "toNumber",
    value: function toNumber(t) {
      var e = Math.clz32;
      var r = t.length;
      if (0 === r) return 0;

      if (1 === r) {
        var _e9 = t.__unsignedDigit(0);

        return t.sign ? -_e9 : _e9;
      }

      var n = t.__digit(r - 1),
          o = e(n),
          i = 32 * r - o;

      if (1024 < i) return t.sign ? -1 / 0 : 1 / 0;
      var s = i - 1,
          c = n,
          a = r - 1;
      var u = o + 1;
      var l = 32 === u ? 0 : c << u;
      l >>>= 12;
      var h = u - 12;
      var f = 12 <= u ? 0 : c << 20 + u,
          d = 20 + u;
      0 < h && 0 < a && (a--, c = t.__digit(a), l |= c >>> 32 - h, f = c << h, d = h), 0 < d && 0 < a && (a--, c = t.__digit(a), f |= c >>> 32 - d, d -= 32);

      var p = qt.__decideRounding(t, d, a, c);

      if ((1 === p || 0 === p && 1 == (1 & f)) && (f = f + 1 >>> 0, 0 == f && (l++, 0 != l >>> 20 && (l = 0, s++, 1023 < s)))) return t.sign ? -1 / 0 : 1 / 0;

      var _ = t.sign ? -2147483648 : 0;

      return s = s + 1023 << 20, qt.__kBitConversionInts[1] = _ | s | l, qt.__kBitConversionInts[0] = f, qt.__kBitConversionDouble[0];
    }
  }, {
    key: "unaryMinus",
    value: function unaryMinus(t) {
      if (0 === t.length) return t;

      var e = t.__copy();

      return e.sign = !t.sign, e;
    }
  }, {
    key: "bitwiseNot",
    value: function bitwiseNot(t) {
      return t.sign ? qt.__absoluteSubOne(t).__trim() : qt.__absoluteAddOne(t, !0);
    }
  }, {
    key: "exponentiate",
    value: function exponentiate(t, e) {
      if (e.sign) throw new RangeError("Exponent must be positive");
      if (0 === e.length) return qt.__oneDigit(1, !1);
      if (0 === t.length) return t;
      if (1 === t.length && 1 === t.__digit(0)) return t.sign && 0 == (1 & e.__digit(0)) ? qt.unaryMinus(t) : t;
      if (1 < e.length) throw new RangeError("BigInt too big");

      var r = e.__unsignedDigit(0);

      if (1 === r) return t;
      if (r >= qt.__kMaxLengthBits) throw new RangeError("BigInt too big");

      if (1 === t.length && 2 === t.__digit(0)) {
        var _e10 = 1 + (r >>> 5),
            _n3 = t.sign && 0 != (1 & r),
            _o4 = new qt(_e10, _n3);

        _o4.__initializeDigits();

        var _i4 = 1 << (31 & r);

        return _o4.__setDigit(_e10 - 1, _i4), _o4;
      }

      var n = null,
          o = t;

      for (0 != (1 & r) && (n = t), r >>= 1; 0 !== r; r >>= 1) {
        o = qt.multiply(o, o), 0 != (1 & r) && (n = null === n ? o : qt.multiply(n, o));
      }

      return n;
    }
  }, {
    key: "multiply",
    value: function multiply(t, e) {
      if (0 === t.length) return t;
      if (0 === e.length) return e;
      var r = t.length + e.length;
      32 <= t.__clzmsd() + e.__clzmsd() && r--;
      var n = new qt(r, t.sign !== e.sign);

      n.__initializeDigits();

      for (var _r10 = 0; _r10 < t.length; _r10++) {
        qt.__multiplyAccumulate(e, t.__digit(_r10), n, _r10);
      }

      return n.__trim();
    }
  }, {
    key: "divide",
    value: function divide(t, e) {
      if (0 === e.length) throw new RangeError("Division by zero");
      if (0 > qt.__absoluteCompare(t, e)) return qt.__zero();

      var r = t.sign !== e.sign,
          n = e.__unsignedDigit(0);

      var o;

      if (1 === e.length && 65535 >= n) {
        if (1 === n) return r === t.sign ? t : qt.unaryMinus(t);
        o = qt.__absoluteDivSmall(t, n, null);
      } else o = qt.__absoluteDivLarge(t, e, !0, !1);

      return o.sign = r, o.__trim();
    }
  }, {
    key: "remainder",
    value: function remainder(t, e) {
      if (0 === e.length) throw new RangeError("Division by zero");
      if (0 > qt.__absoluteCompare(t, e)) return t;

      var r = e.__unsignedDigit(0);

      if (1 === e.length && 65535 >= r) {
        if (1 === r) return qt.__zero();

        var _e11 = qt.__absoluteModSmall(t, r);

        return 0 === _e11 ? qt.__zero() : qt.__oneDigit(_e11, t.sign);
      }

      var n = qt.__absoluteDivLarge(t, e, !1, !0);

      return n.sign = t.sign, n.__trim();
    }
  }, {
    key: "add",
    value: function add(t, e) {
      var r = t.sign;
      return r === e.sign ? qt.__absoluteAdd(t, e, r) : 0 <= qt.__absoluteCompare(t, e) ? qt.__absoluteSub(t, e, r) : qt.__absoluteSub(e, t, !r);
    }
  }, {
    key: "subtract",
    value: function subtract(t, e) {
      var r = t.sign;
      return r === e.sign ? 0 <= qt.__absoluteCompare(t, e) ? qt.__absoluteSub(t, e, r) : qt.__absoluteSub(e, t, !r) : qt.__absoluteAdd(t, e, r);
    }
  }, {
    key: "leftShift",
    value: function leftShift(t, e) {
      return 0 === e.length || 0 === t.length ? t : e.sign ? qt.__rightShiftByAbsolute(t, e) : qt.__leftShiftByAbsolute(t, e);
    }
  }, {
    key: "signedRightShift",
    value: function signedRightShift(t, e) {
      return 0 === e.length || 0 === t.length ? t : e.sign ? qt.__leftShiftByAbsolute(t, e) : qt.__rightShiftByAbsolute(t, e);
    }
  }, {
    key: "unsignedRightShift",
    value: function unsignedRightShift() {
      throw new TypeError("BigInts have no unsigned right shift; use >> instead");
    }
  }, {
    key: "lessThan",
    value: function lessThan(t, e) {
      return 0 > qt.__compareToBigInt(t, e);
    }
  }, {
    key: "lessThanOrEqual",
    value: function lessThanOrEqual(t, e) {
      return 0 >= qt.__compareToBigInt(t, e);
    }
  }, {
    key: "greaterThan",
    value: function greaterThan(t, e) {
      return 0 < qt.__compareToBigInt(t, e);
    }
  }, {
    key: "greaterThanOrEqual",
    value: function greaterThanOrEqual(t, e) {
      return 0 <= qt.__compareToBigInt(t, e);
    }
  }, {
    key: "equal",
    value: function equal(t, e) {
      if (t.sign !== e.sign) return !1;
      if (t.length !== e.length) return !1;

      for (var _r11 = 0; _r11 < t.length; _r11++) {
        if (t.__digit(_r11) !== e.__digit(_r11)) return !1;
      }

      return !0;
    }
  }, {
    key: "notEqual",
    value: function notEqual(t, e) {
      return !qt.equal(t, e);
    }
  }, {
    key: "bitwiseAnd",
    value: function bitwiseAnd(t, e) {
      var _ref;

      var r = Math.max;
      if (!t.sign && !e.sign) return qt.__absoluteAnd(t, e).__trim();

      if (t.sign && e.sign) {
        var _n4 = r(t.length, e.length) + 1;

        var _o5 = qt.__absoluteSubOne(t, _n4);

        var _i5 = qt.__absoluteSubOne(e);

        return _o5 = qt.__absoluteOr(_o5, _i5, _o5), qt.__absoluteAddOne(_o5, !0, _o5).__trim();
      }

      return t.sign && (_ref = [e, t], t = _ref[0], e = _ref[1], _ref), qt.__absoluteAndNot(t, qt.__absoluteSubOne(e)).__trim();
    }
  }, {
    key: "bitwiseXor",
    value: function bitwiseXor(t, e) {
      var _ref2;

      var r = Math.max;
      if (!t.sign && !e.sign) return qt.__absoluteXor(t, e).__trim();

      if (t.sign && e.sign) {
        var _n5 = r(t.length, e.length),
            _o6 = qt.__absoluteSubOne(t, _n5),
            _i6 = qt.__absoluteSubOne(e);

        return qt.__absoluteXor(_o6, _i6, _o6).__trim();
      }

      var n = r(t.length, e.length) + 1;
      t.sign && (_ref2 = [e, t], t = _ref2[0], e = _ref2[1], _ref2);

      var o = qt.__absoluteSubOne(e, n);

      return o = qt.__absoluteXor(o, t, o), qt.__absoluteAddOne(o, !0, o).__trim();
    }
  }, {
    key: "bitwiseOr",
    value: function bitwiseOr(t, e) {
      var _ref3;

      var r = (0, Math.max)(t.length, e.length);
      if (!t.sign && !e.sign) return qt.__absoluteOr(t, e).__trim();

      if (t.sign && e.sign) {
        var _n6 = qt.__absoluteSubOne(t, r);

        var _o7 = qt.__absoluteSubOne(e);

        return _n6 = qt.__absoluteAnd(_n6, _o7, _n6), qt.__absoluteAddOne(_n6, !0, _n6).__trim();
      }

      t.sign && (_ref3 = [e, t], t = _ref3[0], e = _ref3[1], _ref3);

      var n = qt.__absoluteSubOne(e, r);

      return n = qt.__absoluteAndNot(n, t, n), qt.__absoluteAddOne(n, !0, n).__trim();
    }
  }, {
    key: "asIntN",
    value: function asIntN(t, e) {
      if (0 === e.length) return e;
      if (0 === t) return qt.__zero();
      if (t >= qt.__kMaxLengthBits) return e;
      var r = t + 31 >>> 5;
      if (e.length < r) return e;

      var n = e.__unsignedDigit(r - 1),
          o = 1 << (31 & t - 1);

      if (e.length === r && n < o) return e;
      if ((n & o) !== o) return qt.__truncateToNBits(t, e);
      if (!e.sign) return qt.__truncateAndSubFromPowerOfTwo(t, e, !0);

      if (0 == (n & o - 1)) {
        for (var _n7 = r - 2; 0 <= _n7; _n7--) {
          if (0 !== e.__digit(_n7)) return qt.__truncateAndSubFromPowerOfTwo(t, e, !1);
        }

        return e.length === r && n === o ? e : qt.__truncateToNBits(t, e);
      }

      return qt.__truncateAndSubFromPowerOfTwo(t, e, !1);
    }
  }, {
    key: "asUintN",
    value: function asUintN(t, e) {
      if (0 === e.length) return e;
      if (0 === t) return qt.__zero();

      if (e.sign) {
        if (t > qt.__kMaxLengthBits) throw new RangeError("BigInt too big");
        return qt.__truncateAndSubFromPowerOfTwo(t, e, !1);
      }

      if (t >= qt.__kMaxLengthBits) return e;
      var r = t + 31 >>> 5;
      if (e.length < r) return e;
      var n = 31 & t;

      if (e.length == r) {
        if (0 == n) return e;
        if (0 == e.__digit(r - 1) >>> n) return e;
      }

      return qt.__truncateToNBits(t, e);
    }
  }, {
    key: "ADD",
    value: function ADD(t, e) {
      if (t = qt.__toPrimitive(t), e = qt.__toPrimitive(e), "string" == typeof t) return "string" != typeof e && (e = e.toString()), t + e;
      if ("string" == typeof e) return t.toString() + e;
      if (t = qt.__toNumeric(t), e = qt.__toNumeric(e), qt.__isBigInt(t) && qt.__isBigInt(e)) return qt.add(t, e);
      if ("number" == typeof t && "number" == typeof e) return t + e;
      throw new TypeError("Cannot mix BigInt and other types, use explicit conversions");
    }
  }, {
    key: "LT",
    value: function LT(t, e) {
      return qt.__compare(t, e, 0);
    }
  }, {
    key: "LE",
    value: function LE(t, e) {
      return qt.__compare(t, e, 1);
    }
  }, {
    key: "GT",
    value: function GT(t, e) {
      return qt.__compare(t, e, 2);
    }
  }, {
    key: "GE",
    value: function GE(t, e) {
      return qt.__compare(t, e, 3);
    }
  }, {
    key: "EQ",
    value: function EQ(t, e) {
      for (;;) {
        if (qt.__isBigInt(t)) return qt.__isBigInt(e) ? qt.equal(t, e) : qt.EQ(e, t);

        if ("number" == typeof t) {
          if (qt.__isBigInt(e)) return qt.__equalToNumber(e, t);
          if ("object" != typeof e) return t == e;
          e = qt.__toPrimitive(e);
        } else if ("string" == typeof t) {
          if (qt.__isBigInt(e)) return null !== (t = qt.__fromString(t)) && qt.equal(t, e);
          if ("object" != typeof e) return t == e;
          e = qt.__toPrimitive(e);
        } else if ("boolean" == typeof t) {
          if (qt.__isBigInt(e)) return qt.__equalToNumber(e, +t);
          if ("object" != typeof e) return t == e;
          e = qt.__toPrimitive(e);
        } else if ("symbol" == typeof t) {
          if (qt.__isBigInt(e)) return !1;
          if ("object" != typeof e) return t == e;
          e = qt.__toPrimitive(e);
        } else {
          if ("object" != typeof t) return t == e;
          if ("object" == typeof e && e.constructor !== qt) return t == e;
          t = qt.__toPrimitive(t);
        }
      }
    }
  }, {
    key: "NE",
    value: function NE(t, e) {
      return !qt.EQ(t, e);
    }
  }, {
    key: "__zero",
    value: function __zero() {
      return new qt(0, !1);
    }
  }, {
    key: "__oneDigit",
    value: function __oneDigit(t, e) {
      var r = new qt(1, e);
      return r.__setDigit(0, t), r;
    }
  }, {
    key: "__decideRounding",
    value: function __decideRounding(t, e, r, n) {
      if (0 < e) return -1;
      var o;
      if (0 > e) o = -e - 1;else {
        if (0 === r) return -1;
        r--, n = t.__digit(r), o = 31;
      }
      var i = 1 << o;
      if (0 == (n & i)) return -1;
      if (i -= 1, 0 != (n & i)) return 1;

      for (; 0 < r;) {
        if (r--, 0 !== t.__digit(r)) return 1;
      }

      return 0;
    }
  }, {
    key: "__fromDouble",
    value: function __fromDouble(t) {
      qt.__kBitConversionDouble[0] = t;
      var e = (2047 & qt.__kBitConversionInts[1] >>> 20) - 1023,
          r = 1 + (e >>> 5),
          n = new qt(r, 0 > t);
      var o = 1048575 & qt.__kBitConversionInts[1] | 1048576,
          i = qt.__kBitConversionInts[0];
      var s = 31 & e;
      var c,
          a = 0;

      if (s < 20) {
        var _t6 = 20 - s;

        a = _t6 + 32, c = o >>> _t6, o = o << 32 - _t6 | i >>> _t6, i <<= 32 - _t6;
      } else if (20 === s) a = 32, c = o, o = i;else {
        var _t7 = s - 20;

        a = 32 - _t7, c = o << _t7 | i >>> 32 - _t7, o = i << _t7;
      }

      n.__setDigit(r - 1, c);

      for (var _t8 = r - 2; 0 <= _t8; _t8--) {
        0 < a ? (a -= 32, c = o, o = i) : c = 0, n.__setDigit(_t8, c);
      }

      return n.__trim();
    }
  }, {
    key: "__isWhitespace",
    value: function __isWhitespace(t) {
      return !!(13 >= t && 9 <= t) || (159 >= t ? 32 == t : 131071 >= t ? 160 == t || 5760 == t : 196607 >= t ? 10 >= (t &= 131071) || 40 == t || 41 == t || 47 == t || 95 == t || 4096 == t : 65279 == t);
    }
  }, {
    key: "__fromString",
    value: function __fromString(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var r = 0;
      var n = t.length;
      var o = 0;
      if (o === n) return qt.__zero();
      var i = t.charCodeAt(o);

      for (; qt.__isWhitespace(i);) {
        if (++o === n) return qt.__zero();
        i = t.charCodeAt(o);
      }

      if (43 === i) {
        if (++o === n) return null;
        i = t.charCodeAt(o), r = 1;
      } else if (45 === i) {
        if (++o === n) return null;
        i = t.charCodeAt(o), r = -1;
      }

      if (0 === e) {
        if (e = 10, 48 === i) {
          if (++o === n) return qt.__zero();

          if (i = t.charCodeAt(o), 88 === i || 120 === i) {
            if (e = 16, ++o === n) return null;
            i = t.charCodeAt(o);
          } else if (79 === i || 111 === i) {
            if (e = 8, ++o === n) return null;
            i = t.charCodeAt(o);
          } else if (66 === i || 98 === i) {
            if (e = 2, ++o === n) return null;
            i = t.charCodeAt(o);
          }
        }
      } else if (16 === e && 48 === i) {
        if (++o === n) return qt.__zero();

        if (i = t.charCodeAt(o), 88 === i || 120 === i) {
          if (++o === n) return null;
          i = t.charCodeAt(o);
        }
      }

      for (; 48 === i;) {
        if (++o === n) return qt.__zero();
        i = t.charCodeAt(o);
      }

      var s = n - o;
      var c = qt.__kMaxBitsPerChar[e],
          a = qt.__kBitsPerCharTableMultiplier - 1;
      if (s > 1073741824 / c) return null;
      var u = c * s + a >>> qt.__kBitsPerCharTableShift,
          l = new qt(u + 31 >>> 5, !1),
          h = 10 > e ? e : 10,
          f = 10 < e ? e - 10 : 0;

      if (0 == (e & e - 1)) {
        c >>= qt.__kBitsPerCharTableShift;
        var _e12 = [],
            _r12 = [];

        var _s4 = !1;

        do {
          var _a3 = 0,
              _u2 = 0;

          for (;;) {
            var _e13 = void 0;

            if (i - 48 >>> 0 < h) _e13 = i - 48;else {
              if (!((32 | i) - 97 >>> 0 < f)) {
                _s4 = !0;
                break;
              }

              _e13 = (32 | i) - 87;
            }

            if (_u2 += c, _a3 = _a3 << c | _e13, ++o === n) {
              _s4 = !0;
              break;
            }

            if (i = t.charCodeAt(o), 32 < _u2 + c) break;
          }

          _e12.push(_a3), _r12.push(_u2);
        } while (!_s4);

        qt.__fillFromParts(l, _e12, _r12);
      } else {
        l.__initializeDigits();

        var _r13 = !1,
            _s5 = 0;

        do {
          var _u3 = 0,
              _d2 = 1;

          for (;;) {
            var _c5 = void 0;

            if (i - 48 >>> 0 < h) _c5 = i - 48;else {
              if (!((32 | i) - 97 >>> 0 < f)) {
                _r13 = !0;
                break;
              }

              _c5 = (32 | i) - 87;
            }

            var _a4 = _d2 * e;

            if (4294967295 < _a4) break;

            if (_d2 = _a4, _u3 = _u3 * e + _c5, _s5++, ++o === n) {
              _r13 = !0;
              break;
            }

            i = t.charCodeAt(o);
          }

          a = 32 * qt.__kBitsPerCharTableMultiplier - 1;

          var _p2 = c * _s5 + a >>> qt.__kBitsPerCharTableShift + 5;

          l.__inplaceMultiplyAdd(_d2, _u3, _p2);
        } while (!_r13);
      }

      if (o !== n) {
        if (!qt.__isWhitespace(i)) return null;

        for (o++; o < n; o++) {
          if (i = t.charCodeAt(o), !qt.__isWhitespace(i)) return null;
        }
      }

      return 0 != r && 10 !== e ? null : (l.sign = -1 == r, l.__trim());
    }
  }, {
    key: "__fillFromParts",
    value: function __fillFromParts(t, e, r) {
      var n = 0,
          o = 0,
          i = 0;

      for (var _s6 = e.length - 1; 0 <= _s6; _s6--) {
        var _c6 = e[_s6],
            _a5 = r[_s6];
        o |= _c6 << i, i += _a5, 32 === i ? (t.__setDigit(n++, o), i = 0, o = 0) : 32 < i && (t.__setDigit(n++, o), i -= 32, o = _c6 >>> _a5 - i);
      }

      if (0 !== o) {
        if (n >= t.length) throw new Error("implementation bug");

        t.__setDigit(n++, o);
      }

      for (; n < t.length; n++) {
        t.__setDigit(n, 0);
      }
    }
  }, {
    key: "__toStringBasePowerOfTwo",
    value: function __toStringBasePowerOfTwo(t, e) {
      var r = Math.clz32;
      var n = t.length;
      var o = e - 1;
      o = (85 & o >>> 1) + (85 & o), o = (51 & o >>> 2) + (51 & o), o = (15 & o >>> 4) + (15 & o);

      var i = o,
          s = e - 1,
          c = t.__digit(n - 1);

      var a = 0 | (32 * n - r(c) + i - 1) / i;
      if (t.sign && a++, 268435456 < a) throw new Error("string too long");
      var u = Array(a);
      var l = a - 1,
          h = 0,
          f = 0;

      for (var _e14 = 0; _e14 < n - 1; _e14++) {
        var _r14 = t.__digit(_e14),
            _n8 = (h | _r14 << f) & s;

        u[l--] = qt.__kConversionChars[_n8];

        var _o8 = i - f;

        for (h = _r14 >>> _o8, f = 32 - _o8; f >= i;) {
          u[l--] = qt.__kConversionChars[h & s], h >>>= i, f -= i;
        }
      }

      var d = (h | c << f) & s;

      for (u[l--] = qt.__kConversionChars[d], h = c >>> i - f; 0 !== h;) {
        u[l--] = qt.__kConversionChars[h & s], h >>>= i;
      }

      if (t.sign && (u[l--] = "-"), -1 != l) throw new Error("implementation bug");
      return u.join("");
    }
  }, {
    key: "__toStringGeneric",
    value: function __toStringGeneric(t, e, r) {
      var n = Math.clz32;
      var o = t.length;
      if (0 === o) return "";

      if (1 === o) {
        var _n9 = t.__unsignedDigit(0).toString(e);

        return !1 === r && t.sign && (_n9 = "-" + _n9), _n9;
      }

      var i = 32 * o - n(t.__digit(o - 1)),
          s = qt.__kMaxBitsPerChar[e] - 1;
      var c = i * qt.__kBitsPerCharTableMultiplier;
      c += s - 1, c = 0 | c / s;
      var a = c + 1 >> 1,
          u = qt.exponentiate(qt.__oneDigit(e, !1), qt.__oneDigit(a, !1));
      var l, h;

      var f = u.__unsignedDigit(0);

      if (1 === u.length && 65535 >= f) {
        l = new qt(t.length, !1), l.__initializeDigits();
        var _r15 = 0;

        for (var _e15 = 2 * t.length - 1; 0 <= _e15; _e15--) {
          var _n10 = _r15 << 16 | t.__halfDigit(_e15);

          l.__setHalfDigit(_e15, 0 | _n10 / f), _r15 = 0 | _n10 % f;
        }

        h = _r15.toString(e);
      } else {
        var _r16 = qt.__absoluteDivLarge(t, u, !0, !0);

        l = _r16.quotient;

        var _n11 = _r16.remainder.__trim();

        h = qt.__toStringGeneric(_n11, e, !0);
      }

      l.__trim();

      var d = qt.__toStringGeneric(l, e, !0);

      for (; h.length < a;) {
        h = "0" + h;
      }

      return !1 === r && t.sign && (d = "-" + d), d + h;
    }
  }, {
    key: "__unequalSign",
    value: function __unequalSign(t) {
      return t ? -1 : 1;
    }
  }, {
    key: "__absoluteGreater",
    value: function __absoluteGreater(t) {
      return t ? -1 : 1;
    }
  }, {
    key: "__absoluteLess",
    value: function __absoluteLess(t) {
      return t ? 1 : -1;
    }
  }, {
    key: "__compareToBigInt",
    value: function __compareToBigInt(t, e) {
      var r = t.sign;
      if (r !== e.sign) return qt.__unequalSign(r);

      var n = qt.__absoluteCompare(t, e);

      return 0 < n ? qt.__absoluteGreater(r) : 0 > n ? qt.__absoluteLess(r) : 0;
    }
  }, {
    key: "__compareToNumber",
    value: function __compareToNumber(t, e) {
      if (!0 | e) {
        var _r17 = t.sign,
            _n12 = 0 > e;

        if (_r17 !== _n12) return qt.__unequalSign(_r17);

        if (0 === t.length) {
          if (_n12) throw new Error("implementation bug");
          return 0 === e ? 0 : -1;
        }

        if (1 < t.length) return qt.__absoluteGreater(_r17);

        var _o9 = Math.abs(e),
            _i7 = t.__unsignedDigit(0);

        return _i7 > _o9 ? qt.__absoluteGreater(_r17) : _i7 < _o9 ? qt.__absoluteLess(_r17) : 0;
      }

      return qt.__compareToDouble(t, e);
    }
  }, {
    key: "__compareToDouble",
    value: function __compareToDouble(t, e) {
      var r = Math.clz32;
      if (e != e) return e;
      if (e === 1 / 0) return -1;
      if (e === -1 / 0) return 1;
      var n = t.sign;
      if (n !== 0 > e) return qt.__unequalSign(n);
      if (0 === e) throw new Error("implementation bug: should be handled elsewhere");
      if (0 === t.length) return -1;
      qt.__kBitConversionDouble[0] = e;
      var o = 2047 & qt.__kBitConversionInts[1] >>> 20;
      if (2047 == o) throw new Error("implementation bug: handled elsewhere");
      var i = o - 1023;
      if (0 > i) return qt.__absoluteGreater(n);
      var s = t.length;

      var c = t.__digit(s - 1);

      var a = r(c),
          u = 32 * s - a,
          l = i + 1;
      if (u < l) return qt.__absoluteLess(n);
      if (u > l) return qt.__absoluteGreater(n);
      var h = 1048576 | 1048575 & qt.__kBitConversionInts[1],
          f = qt.__kBitConversionInts[0];
      var d = 31 - a;
      if (d !== (u - 1) % 31) throw new Error("implementation bug");
      var p,
          _ = 0;

      if (20 > d) {
        var _t9 = 20 - d;

        _ = _t9 + 32, p = h >>> _t9, h = h << 32 - _t9 | f >>> _t9, f <<= 32 - _t9;
      } else if (20 === d) _ = 32, p = h, h = f;else {
        var _t10 = d - 20;

        _ = 32 - _t10, p = h << _t10 | f >>> 32 - _t10, h = f << _t10;
      }

      if (c >>>= 0, p >>>= 0, c > p) return qt.__absoluteGreater(n);
      if (c < p) return qt.__absoluteLess(n);

      for (var _e16 = s - 2; 0 <= _e16; _e16--) {
        0 < _ ? (_ -= 32, p = h >>> 0, h = f, f = 0) : p = 0;

        var _r18 = t.__unsignedDigit(_e16);

        if (_r18 > p) return qt.__absoluteGreater(n);
        if (_r18 < p) return qt.__absoluteLess(n);
      }

      if (0 !== h || 0 !== f) {
        if (0 === _) throw new Error("implementation bug");
        return qt.__absoluteLess(n);
      }

      return 0;
    }
  }, {
    key: "__equalToNumber",
    value: function __equalToNumber(t, e) {
      var r = Math.abs;
      return e | 0 === e ? 0 === e ? 0 === t.length : 1 === t.length && t.sign === 0 > e && t.__unsignedDigit(0) === r(e) : 0 === qt.__compareToDouble(t, e);
    }
  }, {
    key: "__comparisonResultToBool",
    value: function __comparisonResultToBool(t, e) {
      switch (e) {
        case 0:
          return 0 > t;

        case 1:
          return 0 >= t;

        case 2:
          return 0 < t;

        case 3:
          return 0 <= t;
      }

      throw new Error("unreachable");
    }
  }, {
    key: "__compare",
    value: function __compare(t, e, r) {
      if (t = qt.__toPrimitive(t), e = qt.__toPrimitive(e), "string" == typeof t && "string" == typeof e) switch (r) {
        case 0:
          return t < e;

        case 1:
          return t <= e;

        case 2:
          return t > e;

        case 3:
          return t >= e;
      }
      if (qt.__isBigInt(t) && "string" == typeof e) return null !== (e = qt.__fromString(e)) && qt.__comparisonResultToBool(qt.__compareToBigInt(t, e), r);
      if ("string" == typeof t && qt.__isBigInt(e)) return null !== (t = qt.__fromString(t)) && qt.__comparisonResultToBool(qt.__compareToBigInt(t, e), r);

      if (t = qt.__toNumeric(t), e = qt.__toNumeric(e), qt.__isBigInt(t)) {
        if (qt.__isBigInt(e)) return qt.__comparisonResultToBool(qt.__compareToBigInt(t, e), r);
        if ("number" != typeof e) throw new Error("implementation bug");
        return qt.__comparisonResultToBool(qt.__compareToNumber(t, e), r);
      }

      if ("number" != typeof t) throw new Error("implementation bug");
      if (qt.__isBigInt(e)) return qt.__comparisonResultToBool(qt.__compareToNumber(e, t), 2 ^ r);
      if ("number" != typeof e) throw new Error("implementation bug");
      return 0 === r ? t < e : 1 === r ? t <= e : 2 === r ? t > e : 3 === r ? t >= e : void 0;
    }
  }, {
    key: "__absoluteAdd",
    value: function __absoluteAdd(t, e, r) {
      if (t.length < e.length) return qt.__absoluteAdd(e, t, r);
      if (0 === t.length) return t;
      if (0 === e.length) return t.sign === r ? t : qt.unaryMinus(t);
      var n = t.length;
      (0 === t.__clzmsd() || e.length === t.length && 0 === e.__clzmsd()) && n++;
      var o = new qt(n, r);
      var i = 0,
          s = 0;

      for (; s < e.length; s++) {
        var _r19 = e.__digit(s),
            _n13 = t.__digit(s),
            _c7 = (65535 & _n13) + (65535 & _r19) + i,
            _a6 = (_n13 >>> 16) + (_r19 >>> 16) + (_c7 >>> 16);

        i = _a6 >>> 16, o.__setDigit(s, 65535 & _c7 | _a6 << 16);
      }

      for (; s < t.length; s++) {
        var _e17 = t.__digit(s),
            _r20 = (65535 & _e17) + i,
            _n14 = (_e17 >>> 16) + (_r20 >>> 16);

        i = _n14 >>> 16, o.__setDigit(s, 65535 & _r20 | _n14 << 16);
      }

      return s < o.length && o.__setDigit(s, i), o.__trim();
    }
  }, {
    key: "__absoluteSub",
    value: function __absoluteSub(t, e, r) {
      if (0 === t.length) return t;
      if (0 === e.length) return t.sign === r ? t : qt.unaryMinus(t);
      var n = new qt(t.length, r);
      var o = 0,
          i = 0;

      for (; i < e.length; i++) {
        var _r21 = t.__digit(i),
            _s7 = e.__digit(i),
            _c8 = (65535 & _r21) - (65535 & _s7) - o;

        o = 1 & _c8 >>> 16;

        var _a7 = (_r21 >>> 16) - (_s7 >>> 16) - o;

        o = 1 & _a7 >>> 16, n.__setDigit(i, 65535 & _c8 | _a7 << 16);
      }

      for (; i < t.length; i++) {
        var _e18 = t.__digit(i),
            _r22 = (65535 & _e18) - o;

        o = 1 & _r22 >>> 16;

        var _s8 = (_e18 >>> 16) - o;

        o = 1 & _s8 >>> 16, n.__setDigit(i, 65535 & _r22 | _s8 << 16);
      }

      return n.__trim();
    }
  }, {
    key: "__absoluteAddOne",
    value: function __absoluteAddOne(t, e) {
      var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var n = t.length;
      null === r ? r = new qt(n, e) : r.sign = e;
      var o = !0;

      for (var _e19, _i8 = 0; _i8 < n; _i8++) {
        _e19 = t.__digit(_i8);

        var _n15 = -1 === _e19;

        o && (_e19 = 0 | _e19 + 1), o = _n15, r.__setDigit(_i8, _e19);
      }

      return o && r.__setDigitGrow(n, 1), r;
    }
  }, {
    key: "__absoluteSubOne",
    value: function __absoluteSubOne(t, e) {
      var r = t.length,
          n = new qt(e = e || r, !1);
      var o = !0;

      for (var _e20, _i9 = 0; _i9 < r; _i9++) {
        _e20 = t.__digit(_i9);

        var _r23 = 0 === _e20;

        o && (_e20 = 0 | _e20 - 1), o = _r23, n.__setDigit(_i9, _e20);
      }

      for (var _t11 = r; _t11 < e; _t11++) {
        n.__setDigit(_t11, 0);
      }

      return n;
    }
  }, {
    key: "__absoluteAnd",
    value: function __absoluteAnd(t, e) {
      var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var n = t.length,
          o = e.length,
          i = o;

      if (n < o) {
        i = n;
        var _r24 = t,
            _s9 = n;
        t = e, n = o, e = _r24, o = _s9;
      }

      var s = i;
      null === r ? r = new qt(s, !1) : s = r.length;
      var c = 0;

      for (; c < i; c++) {
        r.__setDigit(c, t.__digit(c) & e.__digit(c));
      }

      for (; c < s; c++) {
        r.__setDigit(c, 0);
      }

      return r;
    }
  }, {
    key: "__absoluteAndNot",
    value: function __absoluteAndNot(t, e) {
      var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var n = t.length,
          o = e.length;
      var i = o;
      n < o && (i = n);
      var s = n;
      null === r ? r = new qt(s, !1) : s = r.length;
      var c = 0;

      for (; c < i; c++) {
        r.__setDigit(c, t.__digit(c) & ~e.__digit(c));
      }

      for (; c < n; c++) {
        r.__setDigit(c, t.__digit(c));
      }

      for (; c < s; c++) {
        r.__setDigit(c, 0);
      }

      return r;
    }
  }, {
    key: "__absoluteOr",
    value: function __absoluteOr(t, e) {
      var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var n = t.length,
          o = e.length,
          i = o;

      if (n < o) {
        i = n;
        var _r25 = t,
            _s10 = n;
        t = e, n = o, e = _r25, o = _s10;
      }

      var s = n;
      null === r ? r = new qt(s, !1) : s = r.length;
      var c = 0;

      for (; c < i; c++) {
        r.__setDigit(c, t.__digit(c) | e.__digit(c));
      }

      for (; c < n; c++) {
        r.__setDigit(c, t.__digit(c));
      }

      for (; c < s; c++) {
        r.__setDigit(c, 0);
      }

      return r;
    }
  }, {
    key: "__absoluteXor",
    value: function __absoluteXor(t, e) {
      var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var n = t.length,
          o = e.length,
          i = o;

      if (n < o) {
        i = n;
        var _r26 = t,
            _s11 = n;
        t = e, n = o, e = _r26, o = _s11;
      }

      var s = n;
      null === r ? r = new qt(s, !1) : s = r.length;
      var c = 0;

      for (; c < i; c++) {
        r.__setDigit(c, t.__digit(c) ^ e.__digit(c));
      }

      for (; c < n; c++) {
        r.__setDigit(c, t.__digit(c));
      }

      for (; c < s; c++) {
        r.__setDigit(c, 0);
      }

      return r;
    }
  }, {
    key: "__absoluteCompare",
    value: function __absoluteCompare(t, e) {
      var r = t.length - e.length;
      if (0 != r) return r;
      var n = t.length - 1;

      for (; 0 <= n && t.__digit(n) === e.__digit(n);) {
        n--;
      }

      return 0 > n ? 0 : t.__unsignedDigit(n) > e.__unsignedDigit(n) ? 1 : -1;
    }
  }, {
    key: "__multiplyAccumulate",
    value: function __multiplyAccumulate(t, e, r, n) {
      var o = Math.imul;
      if (0 === e) return;
      var i = 65535 & e,
          s = e >>> 16;
      var c = 0,
          a = 0,
          u = 0;

      for (var _e21 = 0; _e21 < t.length; _e21++, n++) {
        var _l2 = r.__digit(n),
            _h2 = 65535 & _l2,
            _f2 = _l2 >>> 16;

        var _d3 = t.__digit(_e21),
            _p3 = 65535 & _d3,
            _3 = _d3 >>> 16,
            _g = o(_p3, i),
            _m = o(_p3, s),
            _v = o(_3, i),
            _y = o(_3, s);

        _h2 += a + (65535 & _g), _f2 += u + c + (_h2 >>> 16) + (_g >>> 16) + (65535 & _m) + (65535 & _v), c = _f2 >>> 16, a = (_m >>> 16) + (_v >>> 16) + (65535 & _y) + c, c = a >>> 16, a &= 65535, u = _y >>> 16, _l2 = 65535 & _h2 | _f2 << 16, r.__setDigit(n, _l2);
      }

      for (; 0 != c || 0 !== a || 0 !== u; n++) {
        var _t12 = r.__digit(n);

        var _e22 = (65535 & _t12) + a,
            _o10 = (_t12 >>> 16) + (_e22 >>> 16) + u + c;

        a = 0, u = 0, c = _o10 >>> 16, _t12 = 65535 & _e22 | _o10 << 16, r.__setDigit(n, _t12);
      }
    }
  }, {
    key: "__internalMultiplyAdd",
    value: function __internalMultiplyAdd(t, e, r, n, o) {
      var i = Math.imul;
      var s = r,
          c = 0;

      for (var _r27 = 0; _r27 < n; _r27++) {
        var _n16 = t.__digit(_r27),
            _a8 = i(65535 & _n16, e),
            _u4 = (65535 & _a8) + c + s;

        s = _u4 >>> 16;

        var _l3 = i(_n16 >>> 16, e),
            _h3 = (65535 & _l3) + (_a8 >>> 16) + s;

        s = _h3 >>> 16, c = _l3 >>> 16, o.__setDigit(_r27, _h3 << 16 | 65535 & _u4);
      }

      if (o.length > n) for (o.__setDigit(n++, s + c); n < o.length;) {
        o.__setDigit(n++, 0);
      } else if (0 !== s + c) throw new Error("implementation bug");
    }
  }, {
    key: "__absoluteDivSmall",
    value: function __absoluteDivSmall(t, e, r) {
      null === r && (r = new qt(t.length, !1));
      var n = 0;

      for (var _o11, _i10 = 2 * t.length - 1; 0 <= _i10; _i10 -= 2) {
        _o11 = (n << 16 | t.__halfDigit(_i10)) >>> 0;

        var _s12 = 0 | _o11 / e;

        n = 0 | _o11 % e, _o11 = (n << 16 | t.__halfDigit(_i10 - 1)) >>> 0;

        var _c9 = 0 | _o11 / e;

        n = 0 | _o11 % e, r.__setDigit(_i10 >>> 1, _s12 << 16 | _c9);
      }

      return r;
    }
  }, {
    key: "__absoluteModSmall",
    value: function __absoluteModSmall(t, e) {
      var r = 0;

      for (var _n17 = 2 * t.length - 1; 0 <= _n17; _n17--) {
        r = 0 | ((r << 16 | t.__halfDigit(_n17)) >>> 0) % e;
      }

      return r;
    }
  }, {
    key: "__absoluteDivLarge",
    value: function __absoluteDivLarge(t, e, r, n) {
      var o = Math.imul;

      var i = e.__halfDigitLength(),
          s = e.length,
          c = t.__halfDigitLength() - i;

      var a = null;
      r && (a = new qt(c + 2 >>> 1, !1), a.__initializeDigits());
      var u = new qt(i + 2 >>> 1, !1);

      u.__initializeDigits();

      var l = qt.__clz16(e.__halfDigit(i - 1));

      0 < l && (e = qt.__specialLeftShift(e, l, 0));

      var h = qt.__specialLeftShift(t, l, 1),
          f = e.__halfDigit(i - 1);

      var d = 0;

      for (var _t13, _n18 = c; 0 <= _n18; _n18--) {
        _t13 = 65535;

        var _c10 = h.__halfDigit(_n18 + i);

        if (_c10 !== f) {
          var _r28 = (_c10 << 16 | h.__halfDigit(_n18 + i - 1)) >>> 0;

          _t13 = 0 | _r28 / f;

          var _s13 = 0 | _r28 % f;

          var _a9 = e.__halfDigit(i - 2),
              _u5 = h.__halfDigit(_n18 + i - 2);

          for (; o(_t13, _a9) >>> 0 > (_s13 << 16 | _u5) >>> 0 && (_t13--, _s13 += f, !(65535 < _s13));) {
            ;
          }
        }

        qt.__internalMultiplyAdd(e, _t13, 0, s, u);

        var _l4 = h.__inplaceSub(u, _n18, i + 1);

        0 !== _l4 && (_l4 = h.__inplaceAdd(e, _n18, i), h.__setHalfDigit(_n18 + i, h.__halfDigit(_n18 + i) + _l4), _t13--), r && (1 & _n18 ? d = _t13 << 16 : a.__setDigit(_n18 >>> 1, d | _t13));
      }

      return n ? (h.__inplaceRightShift(l), r ? {
        quotient: a,
        remainder: h
      } : h) : r ? a : void 0;
    }
  }, {
    key: "__clz16",
    value: function __clz16(t) {
      return Math.clz32(t) - 16;
    }
  }, {
    key: "__specialLeftShift",
    value: function __specialLeftShift(t, e, r) {
      var n = t.length,
          o = new qt(n + r, !1);

      if (0 === e) {
        for (var _e23 = 0; _e23 < n; _e23++) {
          o.__setDigit(_e23, t.__digit(_e23));
        }

        return 0 < r && o.__setDigit(n, 0), o;
      }

      var i = 0;

      for (var _r29 = 0; _r29 < n; _r29++) {
        var _n19 = t.__digit(_r29);

        o.__setDigit(_r29, _n19 << e | i), i = _n19 >>> 32 - e;
      }

      return 0 < r && o.__setDigit(n, i), o;
    }
  }, {
    key: "__leftShiftByAbsolute",
    value: function __leftShiftByAbsolute(t, e) {
      var r = qt.__toShiftAmount(e);

      if (0 > r) throw new RangeError("BigInt too big");
      var n = r >>> 5,
          o = 31 & r,
          i = t.length,
          s = 0 !== o && 0 != t.__digit(i - 1) >>> 32 - o,
          c = i + n + (s ? 1 : 0),
          a = new qt(c, t.sign);

      if (0 === o) {
        var _e24 = 0;

        for (; _e24 < n; _e24++) {
          a.__setDigit(_e24, 0);
        }

        for (; _e24 < c; _e24++) {
          a.__setDigit(_e24, t.__digit(_e24 - n));
        }
      } else {
        var _e25 = 0;

        for (var _t14 = 0; _t14 < n; _t14++) {
          a.__setDigit(_t14, 0);
        }

        for (var _r30 = 0; _r30 < i; _r30++) {
          var _i11 = t.__digit(_r30);

          a.__setDigit(_r30 + n, _i11 << o | _e25), _e25 = _i11 >>> 32 - o;
        }

        if (s) a.__setDigit(i + n, _e25);else if (0 != _e25) throw new Error("implementation bug");
      }

      return a.__trim();
    }
  }, {
    key: "__rightShiftByAbsolute",
    value: function __rightShiftByAbsolute(t, e) {
      var r = t.length,
          n = t.sign,
          o = qt.__toShiftAmount(e);

      if (0 > o) return qt.__rightShiftByMaximum(n);
      var i = o >>> 5,
          s = 31 & o;
      var c = r - i;
      if (0 >= c) return qt.__rightShiftByMaximum(n);
      var a = !1;
      if (n) if (0 != (t.__digit(i) & (1 << s) - 1)) a = !0;else for (var _e26 = 0; _e26 < i; _e26++) {
        if (0 !== t.__digit(_e26)) {
          a = !0;
          break;
        }
      }

      if (a && 0 === s) {
        0 == ~t.__digit(r - 1) && c++;
      }

      var u = new qt(c, n);
      if (0 === s) for (var _e27 = i; _e27 < r; _e27++) {
        u.__setDigit(_e27 - i, t.__digit(_e27));
      } else {
        var _e28 = t.__digit(i) >>> s;

        var _n20 = r - i - 1;

        for (var _r31 = 0; _r31 < _n20; _r31++) {
          var _n21 = t.__digit(_r31 + i + 1);

          u.__setDigit(_r31, _n21 << 32 - s | _e28), _e28 = _n21 >>> s;
        }

        u.__setDigit(_n20, _e28);
      }
      return a && (u = qt.__absoluteAddOne(u, !0, u)), u.__trim();
    }
  }, {
    key: "__rightShiftByMaximum",
    value: function __rightShiftByMaximum(t) {
      return t ? qt.__oneDigit(1, !0) : qt.__zero();
    }
  }, {
    key: "__toShiftAmount",
    value: function __toShiftAmount(t) {
      if (1 < t.length) return -1;

      var e = t.__unsignedDigit(0);

      return e > qt.__kMaxLengthBits ? -1 : e;
    }
  }, {
    key: "__toPrimitive",
    value: function __toPrimitive(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "default";
      if ("object" != typeof t) return t;
      if (t.constructor === qt) return t;
      var r = t[Symbol.toPrimitive];

      if (r) {
        var _t15 = r(e);

        if ("object" != typeof _t15) return _t15;
        throw new TypeError("Cannot convert object to primitive value");
      }

      var n = t.valueOf;

      if (n) {
        var _e29 = n.call(t);

        if ("object" != typeof _e29) return _e29;
      }

      var o = t.toString;

      if (o) {
        var _e30 = o.call(t);

        if ("object" != typeof _e30) return _e30;
      }

      throw new TypeError("Cannot convert object to primitive value");
    }
  }, {
    key: "__toNumeric",
    value: function __toNumeric(t) {
      return qt.__isBigInt(t) ? t : +t;
    }
  }, {
    key: "__isBigInt",
    value: function __isBigInt(t) {
      return "object" == typeof t && t.constructor === qt;
    }
  }, {
    key: "__truncateToNBits",
    value: function __truncateToNBits(t, e) {
      var r = t + 31 >>> 5,
          n = new qt(r, e.sign),
          o = r - 1;

      for (var _t16 = 0; _t16 < o; _t16++) {
        n.__setDigit(_t16, e.__digit(_t16));
      }

      var i = e.__digit(o);

      if (0 != (31 & t)) {
        var _e31 = 32 - (31 & t);

        i = i << _e31 >>> _e31;
      }

      return n.__setDigit(o, i), n.__trim();
    }
  }, {
    key: "__truncateAndSubFromPowerOfTwo",
    value: function __truncateAndSubFromPowerOfTwo(t, e, r) {
      var n = Math.min;
      var o = t + 31 >>> 5,
          i = new qt(o, r);
      var s = 0;
      var c = o - 1;
      var a = 0;

      for (var _t17 = n(c, e.length); s < _t17; s++) {
        var _t18 = e.__digit(s),
            _r32 = 0 - (65535 & _t18) - a;

        a = 1 & _r32 >>> 16;

        var _n22 = 0 - (_t18 >>> 16) - a;

        a = 1 & _n22 >>> 16, i.__setDigit(s, 65535 & _r32 | _n22 << 16);
      }

      for (; s < c; s++) {
        i.__setDigit(s, 0 | -a);
      }

      var u = c < e.length ? e.__digit(c) : 0;
      var l = 31 & t;
      var h;

      if (0 == l) {
        var _t19 = 0 - (65535 & u) - a;

        a = 1 & _t19 >>> 16, h = 65535 & _t19 | 0 - (u >>> 16) - a << 16;
      } else {
        var _t20 = 32 - l;

        u = u << _t20 >>> _t20;

        var _e32 = 1 << 32 - _t20,
            _r33 = (65535 & _e32) - (65535 & u) - a;

        a = 1 & _r33 >>> 16, h = 65535 & _r33 | (_e32 >>> 16) - (u >>> 16) - a << 16, h &= _e32 - 1;
      }

      return i.__setDigit(c, h), i.__trim();
    }
  }, {
    key: "__digitPow",
    value: function __digitPow(t, e) {
      var r = 1;

      for (; 0 < e;) {
        1 & e && (r *= t), e >>>= 1, t *= t;
      }

      return r;
    }
  }]);

  return qt;
}( /*#__PURE__*/_wrapNativeSuper(Array));

qt.__kMaxLength = 33554432, qt.__kMaxLengthBits = qt.__kMaxLength << 5, qt.__kMaxBitsPerChar = [0, 0, 32, 51, 64, 75, 83, 90, 96, 102, 107, 111, 115, 119, 122, 126, 128, 131, 134, 136, 139, 141, 143, 145, 147, 149, 151, 153, 154, 156, 158, 159, 160, 162, 163, 165, 166], qt.__kBitsPerCharTableShift = 5, qt.__kBitsPerCharTableMultiplier = 1 << qt.__kBitsPerCharTableShift, qt.__kConversionChars = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z"], qt.__kBitConversionBuffer = new ArrayBuffer(8), qt.__kBitConversionDouble = new Float64Array(qt.__kBitConversionBuffer), qt.__kBitConversionInts = new Int32Array(qt.__kBitConversionBuffer);

var Wt = function (t) {
  var e, r;

  function n(e) {
    var r,
        n = (void 0 === e ? {} : e).supportedChainIds;
    return (r = t.call(this) || this).supportedChainIds = n, r;
  }

  r = t, (e = n).prototype = Object.create(r.prototype), e.prototype.constructor = e, e.__proto__ = r;
  var o = n.prototype;
  return o.emitUpdate = function (t) {
    "production" !== process.env.NODE_ENV && console.log("Emitting '" + st.Update + "' with payload", t), this.emit(st.Update, t);
  }, o.emitError = function (t) {
    "production" !== process.env.NODE_ENV && console.log("Emitting '" + st.Error + "' with payload", t), this.emit(st.Error, t);
  }, o.emitDeactivate = function () {
    "production" !== process.env.NODE_ENV && console.log("Emitting '" + st.Deactivate + "'"), this.emit(st.Deactivate);
  }, n;
}(f);

function $t() {
  return ($t = Object.assign || function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];

      for (var n in r) {
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
      }
    }

    return t;
  }).apply(this, arguments);
}

var zt = {
  1: "mainnet",
  3: "ropsten",
  4: "rinkeby",
  5: "goerli",
  42: "kovan"
},
    Gt = function (t) {
  var e, r;

  function n(e) {
    var r,
        n = e.chainId,
        o = e.config,
        i = void 0 === o ? {} : o;
    return (r = t.call(this, {
      supportedChainIds: [n]
    }) || this).chainId = n, r.config = i, r;
  }

  r = t, (e = n).prototype = Object.create(r.prototype), e.prototype.constructor = e, e.__proto__ = r;
  var o = n.prototype;
  return o.activate = function () {
    try {
      var t = function t() {
        return Promise.resolve(e.authereum.getProvider().enable().then(function (t) {
          return t[0];
        })).then(function () {
          return {
            provider: e.authereum.getProvider()
          };
        });
      },
          e = this,
          r = function () {
        if (!e.authereum) return Promise.resolve(import("./index-c6f22609.js")).then(function (t) {
          var r = t.default;
          e.authereum = new r($t({
            networkName: zt[e.chainId]
          }, e.config));
        });
      }();

      return Promise.resolve(r && r.then ? r.then(t) : t());
    } catch (t) {
      return Promise.reject(t);
    }
  }, o.getProvider = function () {
    try {
      return Promise.resolve(this.authereum.getProvider());
    } catch (t) {
      return Promise.reject(t);
    }
  }, o.getChainId = function () {
    try {
      return Promise.resolve(this.authereum.getNetworkId());
    } catch (t) {
      return Promise.reject(t);
    }
  }, o.getAccount = function () {
    try {
      return Promise.resolve(this.authereum.getAccountAddress());
    } catch (t) {
      return Promise.reject(t);
    }
  }, o.deactivate = function () {}, o.close = function () {
    try {
      return this.authereum.logout(), this.emitDeactivate(), Promise.resolve();
    } catch (t) {
      return Promise.reject(t);
    }
  }, n;
}(Wt);

var Ht = {
  1: "mainnet",
  3: "ropsten",
  4: "rinkeby",
  42: "kovan"
},
    Jt = function (t) {
  var e, r;

  function n(e) {
    var r,
        n = e.apiKey,
        o = e.chainId;
    return Object.keys(Ht).includes(o.toString()) || ("production" !== process.env.NODE_ENV ? ut(!1, "Unsupported chainId " + o) : ut(!1)), (r = t.call(this, {
      supportedChainIds: [o]
    }) || this).apiKey = n, r.chainId = o, r;
  }

  r = t, (e = n).prototype = Object.create(r.prototype), e.prototype.constructor = e, e.__proto__ = r;
  var o = n.prototype;
  return o.activate = function () {
    try {
      var t = function t() {
        return Promise.resolve(e.fortmatic.getProvider().enable().then(function (t) {
          return t[0];
        })).then(function (t) {
          return {
            provider: e.fortmatic.getProvider(),
            chainId: e.chainId,
            account: t
          };
        });
      },
          e = this,
          r = function () {
        if (!e.fortmatic) return Promise.resolve(import("./fortmatic-0568efcb.js")).then(function (t) {
          var r = t.default;
          e.fortmatic = new r(e.apiKey, 1 === e.chainId || 4 === e.chainId ? void 0 : Ht[e.chainId]);
        });
      }();

      return Promise.resolve(r && r.then ? r.then(t) : t());
    } catch (t) {
      return Promise.reject(t);
    }
  }, o.getProvider = function () {
    try {
      return Promise.resolve(this.fortmatic.getProvider());
    } catch (t) {
      return Promise.reject(t);
    }
  }, o.getChainId = function () {
    try {
      return Promise.resolve(this.chainId);
    } catch (t) {
      return Promise.reject(t);
    }
  }, o.getAccount = function () {
    try {
      return Promise.resolve(this.fortmatic.getProvider().send("eth_accounts").then(function (t) {
        return t[0];
      }));
    } catch (t) {
      return Promise.reject(t);
    }
  }, o.deactivate = function () {}, o.close = function () {
    try {
      var t = this;
      return Promise.resolve(t.fortmatic.user.logout()).then(function () {
        t.emitDeactivate();
      });
    } catch (t) {
      return Promise.reject(t);
    }
  }, n;
}(Wt);

var Kt = function Kt(t) {
  return "injected" === t ? "injected" : t.endsWith(".ipc") ? "ipc" : t.startsWith("wss://") || t.startsWith("ws://") ? "ws" : t.startsWith("https://") || t.startsWith("http://") ? "http" : "";
};

var Xt = /*#__PURE__*/function (_h4) {
  _inherits(Xt, _h4);

  var _super2 = _createSuper(Xt);

  function Xt(t) {
    var _this2;

    _classCallCheck(this, Xt);

    _this2 = _super2.call(this), _this2.connected = !1, _this2.nextId = 0, _this2.promises = {}, _this2.subscriptions = [], _this2.connection = t, _this2.connection.on("connect", function () {
      return _this2.checkConnection();
    }), _this2.connection.on("close", function () {
      return _this2.emit("close");
    }), _this2.connection.on("payload", function (t) {
      var e = t.id,
          r = t.method,
          n = t.error,
          o = t.result;
      void 0 !== e ? _this2.promises[e] && (t.error ? _this2.promises[e].reject(n) : _this2.promises[e].resolve(o), delete _this2.promises[e]) : r && r.indexOf("_subscription") > -1 && (_this2.emit(t.params.subscription, t.params.result), _this2.emit(r, t.params), _this2.emit("data", t));
    }), _this2.on("newListener", function (t, e) {
      "networkChanged" === t ? !_this2.attemptedNetworkSubscription && _this2.connected && _this2.startNetworkSubscription() : "accountsChanged" === t && !_this2.attemptedAccountsSubscription && _this2.connected && _this2.startAccountsSubscription();
    });
    return _this2;
  }

  _createClass(Xt, [{
    key: "checkConnection",
    value: function () {
      var _checkConnection = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.t0 = this;
                _context.next = 4;
                return this._send("net_version");

              case 4:
                _context.t1 = _context.sent;

                _context.t0.emit.call(_context.t0, "connect", _context.t1);

                this.connected = !0;
                this.listenerCount("networkChanged") && !this.attemptedNetworkSubscription && this.startNetworkSubscription();
                this.listenerCount("accountsChanged") && !this.attemptedAccountsSubscription && this.startAccountsSubscription();
                _context.next = 14;
                break;

              case 11:
                _context.prev = 11;
                _context.t2 = _context["catch"](0);
                this.connected = !1;

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 11]]);
      }));

      function checkConnection() {
        return _checkConnection.apply(this, arguments);
      }

      return checkConnection;
    }()
  }, {
    key: "startNetworkSubscription",
    value: function () {
      var _startNetworkSubscription = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this3 = this;

        var _t21;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.attemptedNetworkSubscription = !0;
                _context2.prev = 1;
                _context2.next = 4;
                return this.subscribe("eth_subscribe", "networkChanged");

              case 4:
                _t21 = _context2.sent;
                this.on(_t21, function (t) {
                  return _this3.emit("networkChanged", t);
                });
                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](1);
                console.warn("Unable to subscribe to networkChanged", _context2.t0);

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 8]]);
      }));

      function startNetworkSubscription() {
        return _startNetworkSubscription.apply(this, arguments);
      }

      return startNetworkSubscription;
    }()
  }, {
    key: "startAccountsSubscription",
    value: function () {
      var _startAccountsSubscription = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _this4 = this;

        var _t22;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.attemptedAccountsSubscription = !0;
                _context3.prev = 1;
                _context3.next = 4;
                return this.subscribe("eth_subscribe", "accountsChanged");

              case 4:
                _t22 = _context3.sent;
                this.on(_t22, function (t) {
                  return _this4.emit("accountsChanged", t);
                });
                _context3.next = 11;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](1);
                console.warn("Unable to subscribe to accountsChanged", _context3.t0);

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[1, 8]]);
      }));

      function startAccountsSubscription() {
        return _startAccountsSubscription.apply(this, arguments);
      }

      return startAccountsSubscription;
    }()
  }, {
    key: "enable",
    value: function enable() {
      var _this5 = this;

      return new Promise(function (t, e) {
        _this5._send("eth_accounts").then(function (r) {
          if (r.length > 0) _this5.accounts = r, _this5.coinbase = r[0], _this5.emit("enable"), t(r);else {
            var _t23 = new Error("User Denied Full Provider");

            _t23.code = 4001, e(_t23);
          }
        }).catch(e);
      });
    }
  }, {
    key: "_send",
    value: function _send(t) {
      var _this6 = this;

      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      if (!t || "string" != typeof t) return new Error("Method is not a valid string.");
      if (!(e instanceof Array)) return new Error("Params is not a valid array.");
      var r = {
        jsonrpc: "2.0",
        id: this.nextId++,
        method: t,
        params: e
      },
          n = new Promise(function (t, e) {
        _this6.promises[r.id] = {
          resolve: t,
          reject: e
        };
      });
      return this.connection.send(r), n;
    }
  }, {
    key: "send",
    value: function send() {
      return this._send.apply(this, arguments);
    }
  }, {
    key: "_sendBatch",
    value: function _sendBatch(t) {
      var _this7 = this;

      return Promise.all(t.map(function (t) {
        return _this7._send(t.method, t.params);
      }));
    }
  }, {
    key: "subscribe",
    value: function subscribe(t, e) {
      var _this8 = this;

      var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      return this._send(t, [e].concat(_toConsumableArray(r))).then(function (t) {
        return _this8.subscriptions.push(t), t;
      });
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe(t, e) {
      var _this9 = this;

      return this._send(t, [e]).then(function (t) {
        if (t) return _this9.subscriptions = _this9.subscriptions.filter(function (t) {
          return t !== e;
        }), _this9.removeAllListeners(e), t;
      });
    }
  }, {
    key: "sendAsync",
    value: function sendAsync(t, e) {
      return e && "function" == typeof e ? t ? t instanceof Array ? this.sendAsyncBatch(t, e) : this._send(t.method, t.params).then(function (r) {
        e(null, {
          id: t.id,
          jsonrpc: t.jsonrpc,
          result: r
        });
      }).catch(function (t) {
        e(t);
      }) : e(new Error("Invalid Payload")) : e(new Error("Invalid or undefined callback provided to sendAsync"));
    }
  }, {
    key: "sendAsyncBatch",
    value: function sendAsyncBatch(t, e) {
      return this._sendBatch(t).then(function (r) {
        var n = r.map(function (e, r) {
          return {
            id: t[r].id,
            jsonrpc: t[r].jsonrpc,
            result: e
          };
        });
        e(null, n);
      }).catch(function (t) {
        e(t);
      });
    }
  }, {
    key: "isConnected",
    value: function isConnected() {
      return this.connected;
    }
  }, {
    key: "close",
    value: function close() {
      var _this10 = this;

      this.connection.close(), this.connected = !1;
      var t = new Error("Provider closed, subscription lost, please subscribe again.");
      this.subscriptions.forEach(function (e) {
        return _this10.emit(e, t);
      }), this.subscriptions = [];
    }
  }]);

  return Xt;
}(h);

var Yt = "development" === process.env.NODE_ENV;

var Qt = /*#__PURE__*/function (_h5) {
  _inherits(Qt, _h5);

  var _super3 = _createSuper(Qt);

  function Qt(t, e, r) {
    var _this11;

    _classCallCheck(this, Qt);

    _this11 = _super3.call(this), _this11.targets = e, _this11.connections = t, _this11.connected = !1, _this11.status = "loading", _this11.interval = r.interval || 5e3, _this11.name = r.name || "default", _this11.inSetup = !0, _this11.connect();
    return _this11;
  }

  _createClass(Qt, [{
    key: "connect",
    value: function connect() {
      var _this12 = this;

      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      if (Yt && 0 === t && console.log("\n\n\n\nA connection cycle started for provider with name: ".concat(this.name)), this.connection && "connected" === this.connection.status && t >= this.connection.index) Yt && console.log("Stopping connection cycle becasuse we're already connected to a higher priority provider");else if (0 === this.targets.length) Yt && console.log("No valid targets supplied");else {
        var _this$targets$t = this.targets[t],
            _e33 = _this$targets$t.protocol,
            _r34 = _this$targets$t.location;
        this.connection = this.connections[_e33](_r34), this.connection.on("error", function (e) {
          return _this12.connected ? _this12.listenerCount("error") ? _this12.emit("error", e) : void console.warn("eth-provider - Uncaught connection error: " + e.message) : _this12.connectionError(t, e);
        }), this.connection.on("close", function (t) {
          _this12.connected = !1, _this12.emit("close"), _this12.closing || _this12.refresh();
        }), this.connection.on("connect", function () {
          _this12.connection.target = _this12.targets[t], _this12.connection.index = t, _this12.targets[t].status = _this12.connection.status, _this12.connected = !0, _this12.inSetup = !1, Yt && console.log("Successfully connected to: " + _this12.targets[t].location), _this12.emit("connect");
        }), this.connection.on("data", function (t) {
          return _this12.emit("data", t);
        }), this.connection.on("payload", function (t) {
          return _this12.emit("payload", t);
        });
      }
    }
  }, {
    key: "refresh",
    value: function refresh() {
      var _this13 = this;

      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.interval;
      Yt && console.log("Reconnect queued for ".concat((t / 1e3).toFixed(2), "s in the future")), clearTimeout(this.connectTimer), this.connectTimer = setTimeout(function () {
        return _this13.connect();
      }, t);
    }
  }, {
    key: "connectionError",
    value: function connectionError(t, e) {
      this.targets[t].status = e, this.targets.length - 1 === t ? (this.inSetup = !1, Yt && console.warn("eth-provider unable to connect to any targets, view connection cycle summary: ", this.targets), this.refresh()) : this.connect(++t);
    }
  }, {
    key: "close",
    value: function close() {
      this.closing = !0, this.connection ? this.connection.close() : this.emit("close"), clearTimeout(this.connectTimer);
    }
  }, {
    key: "error",
    value: function error(t, e) {
      var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;
      this.emit("payload", {
        id: t.id,
        jsonrpc: t.jsonrpc,
        error: {
          message: e,
          code: r
        }
      });
    }
  }, {
    key: "send",
    value: function send(t) {
      var _this14 = this;

      this.inSetup ? setTimeout(function () {
        return _this14.send(t);
      }, 100) : this.connection.closed ? this.error(t, "Not connected") : this.connection.send(t);
    }
  }]);

  return Qt;
}(h);

var Zt = function Zt(t) {
  function e(e) {
    t.status = e, t instanceof h && t.emit("status", e);
  }

  function r() {
    return _r35.apply(this, arguments);
  }

  function _r35() {
    _r35 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!t.inSetup) {
                _context4.next = 2;
                break;
              }

              return _context4.abrupt("return", setTimeout(r, 1e3));

            case 2:
              _context4.prev = 2;
              _context4.next = 5;
              return t.send("eth_syncing");

            case 5:
              if (!_context4.sent) {
                _context4.next = 9;
                break;
              }

              e("syncing"), setTimeout(function () {
                return r();
              }, 5e3);
              _context4.next = 10;
              break;

            case 9:
              e("connected");

            case 10:
              _context4.next = 15;
              break;

            case 12:
              _context4.prev = 12;
              _context4.t0 = _context4["catch"](2);
              e("disconnected");

            case 15:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[2, 12]]);
    }));
    return _r35.apply(this, arguments);
  }

  return e("loading"), r(), t.on("connect", function () {
    return r();
  }), t.on("close", function () {
    return e("disconnected");
  }), t;
};

var te = {
  injected: ["injected"],
  frame: ["ws://127.0.0.1:1248", "http://127.0.0.1:1248"],
  direct: ["ws://127.0.0.1:8546", "http://127.0.0.1:8545"],
  infura: ["wss://mainnet.infura.io/ws/v3/786ade30f36244469480aa5c2bf0743b", "https://mainnet.infura.io/v3/786ade30f36244469480aa5c2bf0743b"],
  infuraRopsten: ["wss://ropsten.infura.io/ws/v3/786ade30f36244469480aa5c2bf0743b", "https://ropsten.infura.io/v3/786ade30f36244469480aa5c2bf0743b"],
  infuraRinkeby: ["wss://rinkeby.infura.io/ws/v3/786ade30f36244469480aa5c2bf0743b", "https://rinkeby.infura.io/v3/786ade30f36244469480aa5c2bf0743b"],
  infuraKovan: ["wss://kovan.infura.io/ws/v3/786ade30f36244469480aa5c2bf0743b", "https://kovan.infura.io/v3/786ade30f36244469480aa5c2bf0743b"]
};

var ee = /*#__PURE__*/function (_h6) {
  _inherits(ee, _h6);

  var _super4 = _createSuper(ee);

  function ee(t, e) {
    var _this15;

    _classCallCheck(this, ee);

    _this15 = _super4.call(this), t ? setTimeout(function () {
      return _this15.emit("error", new Error("Injected web3 provider is not currently supported"));
    }, 0) : setTimeout(function () {
      return _this15.emit("error", new Error("No injected provider found"));
    }, 0);
    return _this15;
  }

  return ee;
}(h);

var re = /*#__PURE__*/function (_h7) {
  _inherits(re, _h7);

  var _super5 = _createSuper(re);

  function re(t) {
    var _this16;

    _classCallCheck(this, re);

    _this16 = _super5.call(this), setTimeout(function () {
      return _this16.emit("error", new Error(t));
    }, 0);
    return _this16;
  }

  return re;
}(h);

var ne, oe;
var ie = "development" === process.env.NODE_ENV;
var se;

var ce = /*#__PURE__*/function (_h8) {
  _inherits(ce, _h8);

  var _super6 = _createSuper(ce);

  function ce(t, e, r) {
    var _this17;

    _classCallCheck(this, ce);

    _this17 = _super6.call(this), se = t, setTimeout(function () {
      return _this17.create(e, r);
    }, 0);
    return _this17;
  }

  _createClass(ce, [{
    key: "create",
    value: function create(t, e) {
      var _this18 = this;

      se || this.emit("error", new Error("No WebSocket transport available"));

      try {
        this.socket = new se(t);
      } catch (t) {
        return this.emit("error", t);
      }

      this.socket.addEventListener("error", function (t) {
        return _this18.emit("error", t);
      }), this.socket.addEventListener("open", function () {
        _this18.emit("connect"), _this18.socket.addEventListener("message", function (t) {
          (function (t, e) {
            var r = [];
            t.replace(/\}[\n\r]?\{/g, "}|--|{").replace(/\}\][\n\r]?\[\{/g, "}]|--|[{").replace(/\}[\n\r]?\[\{/g, "}|--|[{").replace(/\}\][\n\r]?\{/g, "}]|--|{").split("|--|").forEach(function (t) {
              var n;
              ne && (t = ne + t);

              try {
                n = JSON.parse(t);
              } catch (r) {
                return ne = t, clearTimeout(oe), void (oe = setTimeout(function () {
                  return e(new Error("Parse response timeout"));
                }, 15e3));
              }

              clearTimeout(oe), ne = null, n && r.push(n);
            }), e(null, r);
          })("string" == typeof t.data ? t.data : "", function (t, e) {
            t || e.forEach(function (t) {
              Array.isArray(t) ? t.forEach(function (t) {
                return _this18.emit("payload", t);
              }) : _this18.emit("payload", t);
            });
          });
        }), _this18.socket.addEventListener("close", function () {
          return _this18.onClose();
        });
      });
    }
  }, {
    key: "onClose",
    value: function onClose() {
      this.socket = null, this.closed = !0, ie && console.log("Closing WebSocket connection"), this.emit("close"), this.removeAllListeners();
    }
  }, {
    key: "close",
    value: function close() {
      this.socket ? this.socket.close() : this.onClose();
    }
  }, {
    key: "error",
    value: function error(t, e) {
      var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;
      this.emit("payload", {
        id: t.id,
        jsonrpc: t.jsonrpc,
        error: {
          message: e,
          code: r
        }
      });
    }
  }, {
    key: "send",
    value: function send(t) {
      var _this19 = this;

      this.socket && this.socket.readyState === this.socket.CONNECTING ? setTimeout(function (e) {
        return _this19.send(t);
      }, 10) : !this.socket || this.socket.readyState > 1 ? (this.connected = !1, this.error(t, "Not connected")) : this.socket.send(JSON.stringify(t));
    }
  }]);

  return ce;
}(h);

for (var ae = g(function (t) {
  var e = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || "undefined" != typeof msCrypto && "function" == typeof window.msCrypto.getRandomValues && msCrypto.getRandomValues.bind(msCrypto);

  if (e) {
    var r = new Uint8Array(16);

    t.exports = function () {
      return e(r), r;
    };
  } else {
    var n = new Array(16);

    t.exports = function () {
      for (var t, e = 0; e < 16; e++) {
        0 == (3 & e) && (t = 4294967296 * Math.random()), n[e] = t >>> ((3 & e) << 3) & 255;
      }

      return n;
    };
  }
}), ue = [], le = 0; le < 256; ++le) {
  ue[le] = (le + 256).toString(16).substr(1);
}

var he = function he(t, e) {
  var r = e || 0,
      n = ue;
  return [n[t[r++]], n[t[r++]], n[t[r++]], n[t[r++]], "-", n[t[r++]], n[t[r++]], "-", n[t[r++]], n[t[r++]], "-", n[t[r++]], n[t[r++]], "-", n[t[r++]], n[t[r++]], n[t[r++]], n[t[r++]], n[t[r++]], n[t[r++]]].join("");
};

var fe = function fe(t, e, r) {
  var n = e && r || 0;
  "string" == typeof t && (e = "binary" === t ? new Array(16) : null, t = null);
  var o = (t = t || {}).random || (t.rng || ae)();
  if (o[6] = 15 & o[6] | 64, o[8] = 63 & o[8] | 128, e) for (var i = 0; i < 16; ++i) {
    e[n + i] = o[i];
  }
  return e || he(o);
};

var de = "development" === process.env.NODE_ENV;
var pe;

var _e = /*#__PURE__*/function (_h9) {
  _inherits(_e, _h9);

  var _super7 = _createSuper(_e);

  function _e(t, e, r) {
    var _this20;

    _classCallCheck(this, _e);

    _this20 = _super7.call(this), pe = t, _this20.connected = !1, _this20.subscriptions = !1, _this20.status = "loading", _this20.url = e, _this20.pollId = fe(), setTimeout(function () {
      return _this20.create();
    }, 0);
    return _this20;
  }

  _createClass(_e, [{
    key: "create",
    value: function create() {
      var _this21 = this;

      if (!pe) return this.emit("error", new Error("No HTTP transport available"));
      this.on("error", function () {
        _this21.connected && _this21.close();
      }), this.init();
    }
  }, {
    key: "init",
    value: function init() {
      var _this22 = this;

      this.send({
        jsonrpc: "2.0",
        method: "eth_syncing",
        params: [],
        id: 1
      }, function (t, e) {
        if (t) return _this22.emit("error", t);

        _this22.send({
          jsonrpc: "2.0",
          id: 1,
          method: "eth_pollSubscriptions",
          params: [_this22.pollId, "immediate"]
        }, function (t, e) {
          t || (_this22.subscriptions = !0, _this22.pollSubscriptions()), _this22.connected = !0, _this22.emit("connect");
        });
      });
    }
  }, {
    key: "pollSubscriptions",
    value: function pollSubscriptions() {
      var _this23 = this;

      this.send({
        jsonrpc: "2.0",
        id: 1,
        method: "eth_pollSubscriptions",
        params: [this.pollId]
      }, function (t, e) {
        if (t) return _this23.subscriptionTimeout = setTimeout(function () {
          return _this23.pollSubscriptions();
        }, 1e4), _this23.emit("error", t);
        _this23.closed || (_this23.subscriptionTimeout = _this23.pollSubscriptions()), e && e.map(function (t) {
          var e;

          try {
            e = JSON.parse(t);
          } catch (t) {
            e = !1;
          }

          return e;
        }).filter(function (t) {
          return t;
        }).forEach(function (t) {
          return _this23.emit("payload", t);
        });
      });
    }
  }, {
    key: "close",
    value: function close() {
      de && console.log("Closing HTTP connection"), this.closed = !0, this.emit("close"), clearTimeout(this.subscriptionTimeout), this.removeAllListeners();
    }
  }, {
    key: "filterStatus",
    value: function filterStatus(t) {
      if (t.status >= 200 && t.status < 300) return t;
      var e = new Error(t.statusText);
      throw e.res = t, e.message;
    }
  }, {
    key: "error",
    value: function error(t, e) {
      var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;
      this.emit("payload", {
        id: t.id,
        jsonrpc: t.jsonrpc,
        error: {
          message: e,
          code: r
        }
      });
    }
  }, {
    key: "send",
    value: function send(t, e) {
      var _this24 = this;

      if (this.closed) return this.error(t, "Not connected");

      if ("eth_subscribe" === t.method) {
        if (!this.subscriptions) return this.error(t, "Subscriptions are not supported by this HTTP endpoint");
        t.pollId = this.pollId;
      }

      var r = new pe();
      var n = !1;

      var o = function o(_o12, i) {
        if (!n) if (r.abort(), n = !0, e) e(_o12, i);else {
          var _e34 = t.id,
              _r36 = t.jsonrpc,
              _n23 = _o12 ? {
            id: _e34,
            jsonrpc: _r36,
            error: {
              message: _o12.message,
              code: _o12.code
            }
          } : {
            id: _e34,
            jsonrpc: _r36,
            result: i
          };

          _this24.emit("payload", _n23);
        }
      };

      r.open("POST", this.url, !0), r.setRequestHeader("Content-Type", "application/json"), r.timeout = 6e4, r.onerror = o, r.ontimeout = o, r.onreadystatechange = function () {
        if (4 === r.readyState) try {
          var _t24 = JSON.parse(r.responseText);

          o(_t24.error, _t24.result);
        } catch (t) {
          o(t);
        }
      }, r.send(JSON.stringify(t));
    }
  }]);

  return _e;
}(h);

var ge = {
  ethereum: "undefined" != typeof window && void 0 !== window.ethereum ? window.ethereum : null,
  web3: "undefined" != typeof window && void 0 !== window.web3 ? window.web3.currentProvider : null
},
    me = "undefined" != typeof window && void 0 !== window.WebSocket ? window.WebSocket : null,
    ve = "undefined" != typeof window && void 0 !== window.XMLHttpRequest ? window.XMLHttpRequest : null;
ge.ethereum && (ge.ethereum.__isProvider = !0);
var ye = {
  injected: ge.ethereum || function (t) {
    return function (e) {
      return new ee(t, e);
    };
  }(ge.web3),
  ipc: (be = "IPC connections are unavliable in the browser", function () {
    return new re(be);
  }),
  ws: function (t) {
    return function (e, r) {
      return new ce(t, e, r);
    };
  }(me),
  http: function (t) {
    return function (e, r) {
      return new _e(t, e, r);
    };
  }(ve)
};

var be,
    we = function we() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ["injected", "frame"];
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (t, e, r) {
    if (t.injected.__isProvider && e.map(function (t) {
      return t.type;
    }).indexOf("injected") > -1) return delete t.injected.__isProvider, Zt(t.injected);
    var n = new Xt(new Qt(t, e, r));
    return n.setMaxListeners(128), Zt(n);
  }(ye, function (t, e) {
    var _ref4;

    return (_ref4 = []).concat.apply(_ref4, _toConsumableArray([].concat(t).map(function (t) {
      return e[t] ? e[t].map(function (e) {
        return {
          type: t,
          location: e,
          protocol: Kt(e)
        };
      }) : {
        type: "custom",
        location: t,
        protocol: Kt(t)
      };
    }))).filter(function (t) {
      return !(!t.protocol && "injected" !== t.type) || (console.log('eth-provider | Invalid provider preset/location: "' + t.location + '"'), !1);
    });
  }(t, te), e);
};

function Ee(t, e) {
  t.prototype = Object.create(e.prototype), t.prototype.constructor = t, t.__proto__ = e;
}

function Ce(t) {
  return (Ce = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  })(t);
}

function Oe(t, e) {
  return (Oe = Object.setPrototypeOf || function (t, e) {
    return t.__proto__ = e, t;
  })(t, e);
}

function Pe() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (t) {
    return !1;
  }
}

function Ne(t, e, r) {
  return (Ne = Pe() ? Reflect.construct : function (t, e, r) {
    var n = [null];
    n.push.apply(n, e);
    var o = new (Function.bind.apply(t, n))();
    return r && Oe(o, r.prototype), o;
  }).apply(null, arguments);
}

function Ie(t) {
  var e = "function" == typeof Map ? new Map() : void 0;
  return (Ie = function Ie(t) {
    if (null === t || (r = t, -1 === Function.toString.call(r).indexOf("[native code]"))) return t;
    var r;
    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");

    if (void 0 !== e) {
      if (e.has(t)) return e.get(t);
      e.set(t, n);
    }

    function n() {
      return Ne(t, arguments, Ce(this).constructor);
    }

    return n.prototype = Object.create(t.prototype, {
      constructor: {
        value: n,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), Oe(n, t);
  })(t);
}

function De(t) {
  if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}

var Se = function (t) {
  function e() {
    var e;
    return (e = t.call(this) || this).name = e.constructor.name, e.message = "The user rejected the request.", e;
  }

  return Ee(e, t), e;
}(Ie(Error)),
    Re = function (t) {
  function e(e) {
    var r;
    return 1 !== e.supportedChainIds.length && ("production" !== process.env.NODE_ENV ? ut(!1, "This connector only supports 1 chainId at the moment.") : ut(!1)), (r = t.call(this, e) || this).handleNetworkChanged = r.handleNetworkChanged.bind(De(r)), r.handleChainChanged = r.handleChainChanged.bind(De(r)), r.handleAccountsChanged = r.handleAccountsChanged.bind(De(r)), r.handleClose = r.handleClose.bind(De(r)), r;
  }

  Ee(e, t);
  var r = e.prototype;
  return r.handleNetworkChanged = function (t) {
    "production" !== process.env.NODE_ENV && console.log("Handling 'networkChanged' event with payload", t), this.emitUpdate({
      provider: this.provider,
      chainId: t
    });
  }, r.handleChainChanged = function (t) {
    "production" !== process.env.NODE_ENV && console.log("Handling 'chainChanged' event with payload", t), this.emitUpdate({
      chainId: t
    });
  }, r.handleAccountsChanged = function (t) {
    "production" !== process.env.NODE_ENV && console.log("Handling 'accountsChanged' event with payload", t), this.emitUpdate({
      account: 0 === t.length ? null : t[0]
    });
  }, r.handleClose = function (t, e) {
    "production" !== process.env.NODE_ENV && console.log("Handling 'close' event with payload", t, e), this.emitDeactivate();
  }, r.activate = function () {
    try {
      var t = this;
      return t.provider || (t.provider = we("frame")), t.provider.on("networkChanged", t.handleNetworkChanged).on("chainChanged", t.handleChainChanged).on("accountsChanged", t.handleAccountsChanged).on("close", t.handleClose), Promise.resolve(t.provider.enable().then(function (t) {
        return t[0];
      }).catch(function (t) {
        throw t && 4001 === t.code ? new Se() : t;
      })).then(function (e) {
        return {
          provider: t.provider,
          account: e
        };
      });
    } catch (t) {
      return Promise.reject(t);
    }
  }, r.getProvider = function () {
    try {
      return Promise.resolve(this.provider);
    } catch (t) {
      return Promise.reject(t);
    }
  }, r.getChainId = function () {
    try {
      return Promise.resolve(this.provider.send("eth_chainId"));
    } catch (t) {
      return Promise.reject(t);
    }
  }, r.getAccount = function () {
    try {
      return Promise.resolve(this.provider.send("eth_accounts").then(function (t) {
        return t[0];
      }));
    } catch (t) {
      return Promise.reject(t);
    }
  }, r.deactivate = function () {
    this.provider.removeListener("networkChanged", this.handleNetworkChanged).removeListener("chainChanged", this.handleChainChanged).removeListener("accountsChanged", this.handleAccountsChanged).removeListener("close", this.handleClose);
  }, e;
}(Wt);

function Ae() {
  return (Ae = Object.assign || function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];

      for (var n in r) {
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
      }
    }

    return t;
  }).apply(this, arguments);
}

function ke(t, e) {
  t.prototype = Object.create(e.prototype), t.prototype.constructor = t, t.__proto__ = e;
}

function Te(t) {
  return (Te = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  })(t);
}

function je(t, e) {
  return (je = Object.setPrototypeOf || function (t, e) {
    return t.__proto__ = e, t;
  })(t, e);
}

function xe() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (t) {
    return !1;
  }
}

function Be(t, e, r) {
  return (Be = xe() ? Reflect.construct : function (t, e, r) {
    var n = [null];
    n.push.apply(n, e);
    var o = new (Function.bind.apply(t, n))();
    return r && je(o, r.prototype), o;
  }).apply(null, arguments);
}

function Me(t) {
  var e = "function" == typeof Map ? new Map() : void 0;
  return (Me = function Me(t) {
    if (null === t || (r = t, -1 === Function.toString.call(r).indexOf("[native code]"))) return t;
    var r;
    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");

    if (void 0 !== e) {
      if (e.has(t)) return e.get(t);
      e.set(t, n);
    }

    function n() {
      return Be(t, arguments, Te(this).constructor);
    }

    return n.prototype = Object.create(t.prototype, {
      constructor: {
        value: n,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), je(n, t);
  })(t);
}

function Ue(t) {
  if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}

"undefined" != typeof Symbol && (Symbol.iterator || (Symbol.iterator = Symbol("Symbol.iterator"))), "undefined" != typeof Symbol && (Symbol.asyncIterator || (Symbol.asyncIterator = Symbol("Symbol.asyncIterator")));

function Le(t, e) {
  try {
    var r = t();
  } catch (t) {
    return e(t);
  }

  return r && r.then ? r.then(void 0, e) : r;
}

function Ve(t) {
  return t.hasOwnProperty("result") ? t.result : t;
}

var Fe = function (t) {
  function e() {
    var e;
    return (e = t.call(this) || this).name = e.constructor.name, e.message = "No Ethereum provider was found on window.ethereum.", e;
  }

  return ke(e, t), e;
}(Me(Error)),
    qe = function (t) {
  function e() {
    var e;
    return (e = t.call(this) || this).name = e.constructor.name, e.message = "The user rejected the request.", e;
  }

  return ke(e, t), e;
}(Me(Error)),
    We = function (t) {
  function e(e) {
    var r;
    return (r = t.call(this, e) || this).handleNetworkChanged = r.handleNetworkChanged.bind(Ue(r)), r.handleChainChanged = r.handleChainChanged.bind(Ue(r)), r.handleAccountsChanged = r.handleAccountsChanged.bind(Ue(r)), r.handleClose = r.handleClose.bind(Ue(r)), r;
  }

  ke(e, t);
  var r = e.prototype;
  return r.handleChainChanged = function (t) {
    "production" !== process.env.NODE_ENV && console.log("Handling 'chainChanged' event with payload", t), this.emitUpdate({
      chainId: t,
      provider: window.ethereum
    });
  }, r.handleAccountsChanged = function (t) {
    "production" !== process.env.NODE_ENV && console.log("Handling 'accountsChanged' event with payload", t), 0 === t.length ? this.emitDeactivate() : this.emitUpdate({
      account: t[0]
    });
  }, r.handleClose = function (t, e) {
    "production" !== process.env.NODE_ENV && console.log("Handling 'close' event with payload", t, e), this.emitDeactivate();
  }, r.handleNetworkChanged = function (t) {
    "production" !== process.env.NODE_ENV && console.log("Handling 'networkChanged' event with payload", t), this.emitUpdate({
      chainId: t,
      provider: window.ethereum
    });
  }, r.activate = function () {
    try {
      var t,
          e = function e(_e35) {
        if (r) return _e35;

        function n() {
          return Ae({
            provider: window.ethereum
          }, t ? {
            account: t
          } : {});
        }

        var o = function () {
          if (!t) return Promise.resolve(window.ethereum.enable().then(function (t) {
            return t && Ve(t)[0];
          })).then(function (e) {
            t = e;
          });
        }();

        return o && o.then ? o.then(n) : n();
      },
          r = !1;

      if (!window.ethereum) throw new Fe();
      window.ethereum.on && (window.ethereum.on("chainChanged", this.handleChainChanged), window.ethereum.on("accountsChanged", this.handleAccountsChanged), window.ethereum.on("close", this.handleClose), window.ethereum.on("networkChanged", this.handleNetworkChanged)), window.ethereum.isMetaMask && (window.ethereum.autoRefreshOnNetworkChange = !1);
      var n = Le(function () {
        return Promise.resolve(window.ethereum.send("eth_requestAccounts").then(function (t) {
          return Ve(t)[0];
        })).then(function (e) {
          t = e;
        });
      }, function (t) {
        if (4001 === t.code) throw new qe();
        "production" !== process.env.NODE_ENV && ht(!1, "eth_requestAccounts was unsuccessful, falling back to enable");
      });
      return Promise.resolve(n && n.then ? n.then(e) : e(n));
    } catch (t) {
      return Promise.reject(t);
    }
  }, r.getProvider = function () {
    try {
      return Promise.resolve(window.ethereum);
    } catch (t) {
      return Promise.reject(t);
    }
  }, r.getChainId = function () {
    try {
      var t,
          e = function e() {
        function e() {
          if (!t) try {
            t = Ve(window.ethereum.send({
              method: "net_version"
            }));
          } catch (t) {
            "production" !== process.env.NODE_ENV && ht(!1, "net_version v2 was unsuccessful, falling back to manual matches and static properties");
          }
          return t || (t = window.ethereum.isDapper ? Ve(window.ethereum.cachedResults.net_version) : window.ethereum.chainId || window.ethereum.netVersion || window.ethereum.networkVersion || window.ethereum._chainId), t;
        }

        var r = function () {
          if (!t) {
            var e = Le(function () {
              return Promise.resolve(window.ethereum.send("net_version").then(Ve)).then(function (e) {
                t = e;
              });
            }, function () {
              "production" !== process.env.NODE_ENV && ht(!1, "net_version was unsuccessful, falling back to net version v2");
            });
            if (e && e.then) return e.then(function () {});
          }
        }();

        return r && r.then ? r.then(e) : e();
      };

      if (!window.ethereum) throw new Fe();
      var r = Le(function () {
        return Promise.resolve(window.ethereum.send("eth_chainId").then(Ve)).then(function (e) {
          t = e;
        });
      }, function () {
        "production" !== process.env.NODE_ENV && ht(!1, "eth_chainId was unsuccessful, falling back to net_version");
      });
      return Promise.resolve(r && r.then ? r.then(e) : e());
    } catch (t) {
      return Promise.reject(t);
    }
  }, r.getAccount = function () {
    try {
      var t,
          e = function e() {
        function e() {
          return t || (t = Ve(window.ethereum.send({
            method: "eth_accounts"
          }))[0]), t;
        }

        var r = function () {
          if (!t) {
            var e = Le(function () {
              return Promise.resolve(window.ethereum.enable().then(function (t) {
                return Ve(t)[0];
              })).then(function (e) {
                t = e;
              });
            }, function () {
              "production" !== process.env.NODE_ENV && ht(!1, "enable was unsuccessful, falling back to eth_accounts v2");
            });
            if (e && e.then) return e.then(function () {});
          }
        }();

        return r && r.then ? r.then(e) : e();
      };

      if (!window.ethereum) throw new Fe();
      var r = Le(function () {
        return Promise.resolve(window.ethereum.send("eth_accounts").then(function (t) {
          return Ve(t)[0];
        })).then(function (e) {
          t = e;
        });
      }, function () {
        "production" !== process.env.NODE_ENV && ht(!1, "eth_accounts was unsuccessful, falling back to enable");
      });
      return Promise.resolve(r && r.then ? r.then(e) : e());
    } catch (t) {
      return Promise.reject(t);
    }
  }, r.deactivate = function () {
    window.ethereum && window.ethereum.removeListener && (window.ethereum.removeListener("chainChanged", this.handleChainChanged), window.ethereum.removeListener("accountsChanged", this.handleAccountsChanged), window.ethereum.removeListener("close", this.handleClose), window.ethereum.removeListener("networkChanged", this.handleNetworkChanged));
  }, r.isAuthorized = function () {
    try {
      return window.ethereum ? Promise.resolve(Le(function () {
        return Promise.resolve(window.ethereum.send("eth_accounts").then(function (t) {
          return Ve(t).length > 0;
        }));
      }, function () {
        return !1;
      })) : Promise.resolve(!1);
    } catch (t) {
      return Promise.reject(t);
    }
  }, e;
}(Wt);

function $e(t) {
  if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}

var ze = {
  1: "mainnet",
  3: "ropsten",
  4: "rinkeby",
  5: "goerli",
  42: "kovan",
  100: "xdai",
  30: "orchid",
  31: "orchidTestnet",
  99: "core",
  77: "sokol",
  61: "classic",
  8: "ubiq",
  108: "thundercore",
  18: "thundercoreTestnet",
  163: "lightstreams",
  122: "fuse",
  15001: "maticTestnet"
},
    Ge = function (t) {
  var e, r;

  function n(e) {
    var r,
        n = e.dAppId,
        o = e.networks,
        i = e.config,
        s = void 0 === i ? {} : i,
        c = o.map(function (t) {
      return "number" == typeof t ? t : Number(t.chainId);
    });
    return c.every(function (t) {
      return !!ze[t];
    }) || ("production" !== process.env.NODE_ENV ? ut(!1, "One or more unsupported networks " + o) : ut(!1)), (r = t.call(this, {
      supportedChainIds: c
    }) || this).dAppId = n, r.networks = o, r.config = s, r.handleOnLogout = r.handleOnLogout.bind($e(r)), r.handleOnActiveWalletChanged = r.handleOnActiveWalletChanged.bind($e(r)), r.handleOnError = r.handleOnError.bind($e(r)), r;
  }

  r = t, (e = n).prototype = Object.create(r.prototype), e.prototype.constructor = e, e.__proto__ = r;
  var o = n.prototype;
  return o.handleOnLogout = function () {
    "production" !== process.env.NODE_ENV && console.log("Handling 'onLogout' event"), this.emitDeactivate();
  }, o.handleOnActiveWalletChanged = function (t) {
    "production" !== process.env.NODE_ENV && console.log("Handling 'onActiveWalletChanged' event with payload", t), this.emitUpdate({
      account: t
    });
  }, o.handleOnError = function (t) {
    "production" !== process.env.NODE_ENV && console.log("Handling 'onError' event"), this.emitError(t);
  }, o.activate = function () {
    try {
      var t = function t() {
        return e.portis.onLogout(e.handleOnLogout), e.portis.onActiveWalletChanged(e.handleOnActiveWalletChanged), e.portis.onError(e.handleOnError), Promise.resolve(e.portis.provider.enable().then(function (t) {
          return t[0];
        })).then(function (t) {
          return {
            provider: e.portis.provider,
            account: t
          };
        });
      },
          e = this,
          r = function () {
        if (!e.portis) return Promise.resolve(import("./index-b6b58529.js")).then(function (t) {
          var r = t.default;
          e.portis = new r(e.dAppId, "number" == typeof e.networks[0] ? ze[e.networks[0]] : e.networks[0], e.config);
        });
      }();

      return Promise.resolve(r && r.then ? r.then(t) : t());
    } catch (t) {
      return Promise.reject(t);
    }
  }, o.getProvider = function () {
    try {
      return Promise.resolve(this.portis.provider);
    } catch (t) {
      return Promise.reject(t);
    }
  }, o.getChainId = function () {
    try {
      return Promise.resolve(this.portis.provider.send("eth_chainId"));
    } catch (t) {
      return Promise.reject(t);
    }
  }, o.getAccount = function () {
    try {
      return Promise.resolve(this.portis.provider.send("eth_accounts").then(function (t) {
        return t[0];
      }));
    } catch (t) {
      return Promise.reject(t);
    }
  }, o.deactivate = function () {
    this.portis.onLogout(function () {}), this.portis.onActiveWalletChanged(function () {}), this.portis.onError(function () {});
  }, o.changeNetwork = function (t, e) {
    try {
      return "number" == typeof t ? (ze[t] || ("production" !== process.env.NODE_ENV ? ut(!1, "Invalid chainId " + t) : ut(!1)), this.portis.changeNetwork(ze[t], e), this.emitUpdate({
        chainId: t
      })) : (this.portis.changeNetwork(t, e), this.emitUpdate({
        chainId: Number(t.chainId)
      })), Promise.resolve();
    } catch (t) {
      return Promise.reject(t);
    }
  }, o.close = function () {
    try {
      var t = this;
      return Promise.resolve(t.portis.logout()).then(function () {
        t.emitDeactivate();
      });
    } catch (t) {
      return Promise.reject(t);
    }
  }, n;
}(Wt);

var He = {
  1: "mainnet",
  3: "ropsten",
  4: "rinkeby",
  5: "goerli",
  42: "kovan",
  100: "xdai"
},
    Je = function (t) {
  var e, r;

  function n(e) {
    var r,
        n = e.clientId,
        o = e.networks,
        i = e.options,
        s = void 0 === i ? {} : i,
        c = o.map(function (t) {
      return "number" == typeof t ? t : t.chainId;
    });
    return c.every(function (t) {
      return !!He[t];
    }) || ("production" !== process.env.NODE_ENV ? ut(!1, "One or more unsupported networks " + o) : ut(!1)), (r = t.call(this, {
      supportedChainIds: c
    }) || this).clientId = n, r.networks = o, r.options = s, r;
  }

  r = t, (e = n).prototype = Object.create(r.prototype), e.prototype.constructor = e, e.__proto__ = r;
  var o = n.prototype;
  return o.activate = function () {
    try {
      var t = function t() {
        return Promise.resolve(e.squarelink.getProvider()).then(function (t) {
          return Promise.resolve(t.enable().then(function (t) {
            return t[0];
          })).then(function (e) {
            return {
              provider: t,
              account: e
            };
          });
        });
      },
          e = this,
          r = function () {
        if (!e.squarelink) return Promise.resolve(import("squarelink")).then(function (t) {
          var r = t.default;
          e.squarelink = new r(e.clientId, "number" == typeof e.networks[0] ? He[e.networks[0]] : e.networks[0], e.options);
        });
      }();

      return Promise.resolve(r && r.then ? r.then(t) : t());
    } catch (t) {
      return Promise.reject(t);
    }
  }, o.getProvider = function () {
    try {
      return Promise.resolve(this.squarelink.getProvider());
    } catch (t) {
      return Promise.reject(t);
    }
  }, o.getChainId = function () {
    try {
      return Promise.resolve(this.squarelink.getProvider().then(function (t) {
        return t.send("eth_chainId");
      }));
    } catch (t) {
      return Promise.reject(t);
    }
  }, o.getAccount = function () {
    try {
      return Promise.resolve(this.squarelink.getProvider().then(function (t) {
        return t.send("eth_accounts").then(function (t) {
          return t[0];
        });
      }));
    } catch (t) {
      return Promise.reject(t);
    }
  }, o.deactivate = function () {}, n;
}(Wt);

function Ke() {
  return (Ke = Object.assign || function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];

      for (var n in r) {
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
      }
    }

    return t;
  }).apply(this, arguments);
}

var Xe = function (t) {
  var e, r;

  function n(e) {
    var r,
        n = e.url,
        o = e.appName,
        i = e.appLogoUrl,
        s = e.darkMode;
    return (r = t.call(this, {
      supportedChainIds: [1]
    }) || this).url = n, r.appName = o, r.appLogoUrl = i, r.darkMode = s || !1, r;
  }

  r = t, (e = n).prototype = Object.create(r.prototype), e.prototype.constructor = e, e.__proto__ = r;
  var o = n.prototype;
  return o.activate = function () {
    try {
      var t = function t() {
        return Promise.resolve(e.provider.send("eth_requestAccounts").then(function (t) {
          return t[0];
        })).then(function (t) {
          return {
            provider: e.provider,
            chainId: 1,
            account: t
          };
        });
      },
          e = this,
          r = function () {
        if (!e.walletLink) return Promise.resolve(import("./index-a004146a.js")).then(function (t) {
          var r = t.default;
          e.walletLink = new r(Ke({
            appName: e.appName,
            darkMode: e.darkMode
          }, e.appLogoUrl ? {
            appLogoUrl: e.appLogoUrl
          } : {})), e.provider = e.walletLink.makeWeb3Provider(e.url, 1);
        });
      }();

      return Promise.resolve(r && r.then ? r.then(t) : t());
    } catch (t) {
      return Promise.reject(t);
    }
  }, o.getProvider = function () {
    try {
      return Promise.resolve(this.provider);
    } catch (t) {
      return Promise.reject(t);
    }
  }, o.getChainId = function () {
    return Promise.resolve(1);
  }, o.getAccount = function () {
    try {
      return Promise.resolve(this.provider.send("eth_accounts").then(function (t) {
        return t[0];
      }));
    } catch (t) {
      return Promise.reject(t);
    }
  }, o.deactivate = function () {}, o.close = function () {
    try {
      return this.provider.close(), this.emitDeactivate(), Promise.resolve();
    } catch (t) {
      return Promise.reject(t);
    }
  }, n;
}(Wt);

var Ye = new Map([["1", "Mainnet"], ["2", "Expanse"], ["3", "Ropsten"], ["4", "Rinkeby"], ["5", "Goerli"], ["42", "Kovan"], ["100", "xDai"], ["1337", "Local"], ["5777", "Ganache"]]);

function Qe(t) {
  return t = String(t), Ye.get(t) || "Unknown";
}

function Ze(t) {
  if ("object" == typeof t && "jsonrpc" in t) {
    if (t.error) throw new Error(t.error);
    return t.result || null;
  }

  return t || null;
}

function tr(_x, _x2, _x3) {
  return _tr.apply(this, arguments);
}

function _tr() {
  _tr = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(t, e, r) {
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            return _context11.abrupt("return", t.sendAsync && t.selectedAddress ? new Promise(function (n, o) {
              t.sendAsync({
                method: e,
                params: r,
                from: t.selectedAddress,
                jsonrpc: "2.0",
                id: 0
              }, function (t, e) {
                t ? o(t) : n(e);
              });
            }).then(Ze) : t.send(e, r).then(Ze));

          case 1:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));
  return _tr.apply(this, arguments);
}

function er(t, e) {
  var r = -1,
      n = !1;

  var o = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(t, i) {
      var s;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return t();

            case 2:
              s = _context5.sent;
              n || (i(s), r = setTimeout(o.bind(null, t, i), e));

            case 4:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function o(_x4, _x5) {
      return _ref5.apply(this, arguments);
    };
  }();

  return function () {
    var _t25 = t.apply(void 0, arguments),
        i = _t25.request,
        s = _t25.onResult;

    return n = !1, o(i, s), function () {
      n = !0, clearTimeout(r);
    };
  };
}

var rr = /*#__PURE__*/function (_Error) {
  _inherits(rr, _Error);

  var _super8 = _createSuper(rr);

  function rr(t, e) {
    var _this25;

    _classCallCheck(this, rr);

    for (var _len4 = arguments.length, r = new Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
      r[_key4 - 2] = arguments[_key4];
    }

    _this25 = _super8.call.apply(_super8, [this].concat(r)), _this25.name = "ChainUnsupportedError", _this25.message = "Unsupported chain: ".concat(Qe(t)).concat(-1 === t ? "" : " (Chain ID: ".concat(t, ")"), ". ") + "Required chain: ".concat(Qe(e), " (Chain ID: ").concat(e, ").");
    return _this25;
  }

  return rr;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var nr = /*#__PURE__*/function (_Error2) {
  _inherits(nr, _Error2);

  var _super9 = _createSuper(nr);

  function nr(t) {
    var _this26;

    _classCallCheck(this, nr);

    for (var _len5 = arguments.length, e = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
      e[_key5 - 1] = arguments[_key5];
    }

    _this26 = _super9.call.apply(_super9, [this].concat(e)), _this26.name = "ConnectorUnsupportedError", _this26.message = "Unsupported connector: ".concat(t, ".");
    return _this26;
  }

  return nr;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var or = /*#__PURE__*/function (_Error3) {
  _inherits(or, _Error3);

  var _super10 = _createSuper(or);

  function or() {
    var _this27;

    _classCallCheck(this, or);

    for (var _len6 = arguments.length, t = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      t[_key6] = arguments[_key6];
    }

    _this27 = _super10.call.apply(_super10, [this].concat(t)), _this27.name = "ConnectionRejectedError", _this27.message = "The activation has been rejected by the provider.";
    return _this27;
  }

  return or;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var ir = /*#__PURE__*/function (_Error4) {
  _inherits(ir, _Error4);

  var _super11 = _createSuper(ir);

  function ir() {
    var _this28;

    _classCallCheck(this, ir);

    for (var _len7 = arguments.length, t = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
      t[_key7] = arguments[_key7];
    }

    _this28 = _super11.call.apply(_super11, [this].concat(t)), _this28.name = "ConnectorConfigError";
    return _this28;
  }

  return ir;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var sr;
!function (t) {
  t.Update = "Web3ReactUpdate", t.Error = "Web3ReactError", t.Deactivate = "Web3ReactDeactivate";
}(sr || (sr = {}));

var cr = function (t) {
  var e, r;

  function n(e) {
    var r,
        n = (void 0 === e ? {} : e).supportedChainIds;
    return (r = t.call(this) || this).supportedChainIds = n, r;
  }

  r = t, (e = n).prototype = Object.create(r.prototype), e.prototype.constructor = e, e.__proto__ = r;
  var o = n.prototype;
  return o.emitUpdate = function (t) {
    "production" !== process.env.NODE_ENV && console.log("Emitting '" + sr.Update + "' with payload", t), this.emit(sr.Update, t);
  }, o.emitError = function (t) {
    "production" !== process.env.NODE_ENV && console.log("Emitting '" + sr.Error + "' with payload", t), this.emit(sr.Error, t);
  }, o.emitDeactivate = function () {
    "production" !== process.env.NODE_ENV && console.log("Emitting '" + sr.Deactivate + "'"), this.emit(sr.Deactivate);
  }, n;
}(f),
    ar = "production" === process.env.NODE_ENV;

function ur(t, e) {
  if (!t) {
    if (ar) throw new Error("Invariant failed");
    throw new Error("Invariant failed: " + (e || ""));
  }
}

function lr(t, e) {
  t.prototype = Object.create(e.prototype), t.prototype.constructor = t, t.__proto__ = e;
}

function hr(t) {
  return (hr = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  })(t);
}

function fr(t, e) {
  return (fr = Object.setPrototypeOf || function (t, e) {
    return t.__proto__ = e, t;
  })(t, e);
}

function dr() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (t) {
    return !1;
  }
}

function pr(t, e, r) {
  return (pr = dr() ? Reflect.construct : function (t, e, r) {
    var n = [null];
    n.push.apply(n, e);
    var o = new (Function.bind.apply(t, n))();
    return r && fr(o, r.prototype), o;
  }).apply(null, arguments);
}

function _r(t) {
  var e = "function" == typeof Map ? new Map() : void 0;
  return (_r = function _r(t) {
    if (null === t || (r = t, -1 === Function.toString.call(r).indexOf("[native code]"))) return t;
    var r;
    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");

    if (void 0 !== e) {
      if (e.has(t)) return e.get(t);
      e.set(t, n);
    }

    function n() {
      return pr(t, arguments, hr(this).constructor);
    }

    return n.prototype = Object.create(t.prototype, {
      constructor: {
        value: n,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), fr(n, t);
  })(t);
}

function gr(t) {
  if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}

var mr = function (t) {
  function e() {
    var e;
    return (e = t.call(this) || this).name = e.constructor.name, e.message = "The user rejected the request.", e;
  }

  return lr(e, t), e;
}(_r(Error)),
    vr = function (t) {
  function e(e) {
    var r,
        n = e.rpc,
        o = e.bridge,
        i = e.qrcode,
        s = e.pollingInterval;
    return 1 !== Object.keys(n).length && ("production" !== process.env.NODE_ENV ? ur(!1, "@walletconnect/web3-provider is broken with >1 chainId, please use 1") : ur(!1)), (r = t.call(this, {
      supportedChainIds: Object.keys(n).map(function (t) {
        return Number(t);
      })
    }) || this).rpc = n, r.bridge = o, r.qrcode = i, r.pollingInterval = s, r.handleChainChanged = r.handleChainChanged.bind(gr(r)), r.handleAccountsChanged = r.handleAccountsChanged.bind(gr(r)), r.handleDisconnect = r.handleDisconnect.bind(gr(r)), r;
  }

  lr(e, t);
  var r = e.prototype;
  return r.handleChainChanged = function (t) {
    "production" !== process.env.NODE_ENV && console.log("Handling 'chainChanged' event with payload", t), this.emitUpdate({
      chainId: t
    });
  }, r.handleAccountsChanged = function (t) {
    "production" !== process.env.NODE_ENV && console.log("Handling 'accountsChanged' event with payload", t), this.emitUpdate({
      account: t[0]
    });
  }, r.handleDisconnect = function () {
    "production" !== process.env.NODE_ENV && console.log("Handling 'disconnect' event"), this.emitDeactivate(), this.walletConnectProvider && (this.walletConnectProvider.stop(), this.walletConnectProvider.removeListener("chainChanged", this.handleChainChanged), this.walletConnectProvider.removeListener("accountsChanged", this.handleAccountsChanged), this.walletConnectProvider = void 0), this.emitDeactivate();
  }, r.activate = function () {
    try {
      var t = function t() {
        function t() {
          return Promise.resolve(e.walletConnectProvider.enable().then(function (t) {
            return t[0];
          }).catch(function (t) {
            if ("User closed modal" === t.message) throw new mr();
            throw t;
          })).then(function (t) {
            return e.walletConnectProvider.on("disconnect", e.handleDisconnect), e.walletConnectProvider.on("chainChanged", e.handleChainChanged), e.walletConnectProvider.on("accountsChanged", e.handleAccountsChanged), {
              provider: e.walletConnectProvider,
              account: t
            };
          });
        }

        var r = function () {
          if (!e.walletConnectProvider.wc.connected) return Promise.resolve(e.walletConnectProvider.wc.createSession({
            chainId: Number(Object.keys(e.rpc)[0])
          })).then(function () {
            e.emit("URI_AVAILABLE", e.walletConnectProvider.wc.uri);
          });
        }();

        return r && r.then ? r.then(t) : t();
      },
          e = this,
          r = function () {
        if (!e.walletConnectProvider) return Promise.resolve(import("./index-1d2649b8.js").then(function (t) {
          var e;
          return null != (e = null == t ? void 0 : t.default) ? e : t;
        })).then(function (t) {
          e.walletConnectProvider = new t({
            bridge: e.bridge,
            rpc: e.rpc,
            qrcode: e.qrcode,
            pollingInterval: e.pollingInterval
          });
        });
      }();

      return Promise.resolve(r && r.then ? r.then(t) : t());
    } catch (t) {
      return Promise.reject(t);
    }
  }, r.getProvider = function () {
    try {
      return Promise.resolve(this.walletConnectProvider);
    } catch (t) {
      return Promise.reject(t);
    }
  }, r.getChainId = function () {
    try {
      return Promise.resolve(this.walletConnectProvider.send("eth_chainId"));
    } catch (t) {
      return Promise.reject(t);
    }
  }, r.getAccount = function () {
    try {
      return Promise.resolve(this.walletConnectProvider.send("eth_accounts").then(function (t) {
        return t[0];
      }));
    } catch (t) {
      return Promise.reject(t);
    }
  }, r.deactivate = function () {
    this.walletConnectProvider && (this.walletConnectProvider.stop(), this.walletConnectProvider.removeListener("disconnect", this.handleDisconnect), this.walletConnectProvider.removeListener("chainChanged", this.handleChainChanged), this.walletConnectProvider.removeListener("accountsChanged", this.handleAccountsChanged));
  }, r.close = function () {
    try {
      var t;
      return Promise.resolve(null == (t = this.walletConnectProvider) ? void 0 : t.close()).then(function () {});
    } catch (t) {
      return Promise.reject(t);
    }
  }, e;
}(cr);

var yr = function (t) {
  var e, r;

  function n(e) {
    var r,
        n = e.chainId,
        o = e.initOptions,
        i = void 0 === o ? {} : o,
        s = e.constructorOptions,
        c = void 0 === s ? {} : s,
        a = e.loginOptions,
        u = void 0 === a ? {} : a;
    return (r = t.call(this, {
      supportedChainIds: [n]
    }) || this).chainId = n, r.initOptions = i, r.constructorOptions = c, r.loginOptions = u, r;
  }

  r = t, (e = n).prototype = Object.create(r.prototype), e.prototype.constructor = e, e.__proto__ = r;
  var o = n.prototype;
  return o.activate = function () {
    try {
      var t = function t() {
        return Promise.resolve(e.torus.login(e.loginOptions).then(function (t) {
          return t[0];
        })).then(function (t) {
          return {
            provider: e.torus.provider,
            account: t
          };
        });
      },
          e = this,
          r = function () {
        if (!e.torus) return Promise.resolve(import("./torus.cjs-c0df7a64.js")).then(function (t) {
          var r = t.default;
          return e.torus = new r(e.constructorOptions), Promise.resolve(e.torus.init(e.initOptions)).then(function () {});
        });
      }();

      return Promise.resolve(r && r.then ? r.then(t) : t());
    } catch (t) {
      return Promise.reject(t);
    }
  }, o.getProvider = function () {
    try {
      return Promise.resolve(this.torus.provider);
    } catch (t) {
      return Promise.reject(t);
    }
  }, o.getChainId = function () {
    try {
      return Promise.resolve(this.chainId);
    } catch (t) {
      return Promise.reject(t);
    }
  }, o.getAccount = function () {
    try {
      return Promise.resolve(this.torus.ethereum.send("eth_accounts").then(function (t) {
        return t[0];
      }));
    } catch (t) {
      return Promise.reject(t);
    }
  }, o.deactivate = function () {
    try {
      var t = this;
      return Promise.resolve(t.torus.cleanUp()).then(function () {
        t.torus = void 0;
      });
    } catch (t) {
      return Promise.reject(t);
    }
  }, o.close = function () {
    try {
      var t = this;
      return Promise.resolve(t.torus.logout()).then(function () {
        t.emitDeactivate();
      });
    } catch (t) {
      return Promise.reject(t);
    }
  }, n;
}(Wt);

var br = t.createContext(null);

function wr() {
  var t = r(br);
  if (null === t) throw new Error("useWallet() can only be used inside of <UseWalletProvider />, please declare it at a higher level.");

  var n = function () {
    var t = r(br),
        _a10 = a(null),
        _a11 = _slicedToArray(_a10, 2),
        e = _a11[0],
        n = _a11[1],
        c = o(!1),
        u = i(function () {
      return c.current = !0, t.addBlockNumberListener(n), e;
    }, [t, e]);

    return s(function () {
      if (c.current) return t.addBlockNumberListener(n), function () {
        t.removeBlockNumberListener(n);
      };
    }, [c, t]), u;
  }(),
      c = t.wallet;

  return e(function () {
    return _objectSpread(_objectSpread({}, c), {}, {
      getBlockNumber: n
    });
  }, [n, c]);
}

function Er(_ref6) {
  var t = _ref6.account,
      e = _ref6.ethereum,
      r = _ref6.pollBalanceInterval;

  var _a12 = a("-1"),
      _a13 = _slicedToArray(_a12, 2),
      n = _a13[0],
      o = _a13[1];

  return s(function () {
    if (!t || !e) return;
    var n = !1;
    var i = er(function (t, e, r) {
      var o = "-1";
      return {
        request: function () {
          var _request = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
            return _regeneratorRuntime.wrap(function _callee7$(_context7) {
              while (1) {
                switch (_context7.prev = _context7.next) {
                  case 0:
                    return _context7.abrupt("return", function () {
                      var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(t, e) {
                        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                          while (1) {
                            switch (_context6.prev = _context6.next) {
                              case 0:
                                return _context6.abrupt("return", tr(t, "eth_getBalance", [e, "latest"]));

                              case 1:
                              case "end":
                                return _context6.stop();
                            }
                          }
                        }, _callee6);
                      }));

                      return function (_x6, _x7) {
                        return _ref7.apply(this, arguments);
                      };
                    }()(e, t).then(function (t) {
                      return t ? qt.BigInt(t).toString() : "-1";
                    }).catch(function () {
                      return "-1";
                    }));

                  case 1:
                  case "end":
                    return _context7.stop();
                }
              }
            }, _callee7);
          }));

          function request() {
            return _request.apply(this, arguments);
          }

          return request;
        }(),
        onResult: function onResult(t) {
          n || t === o || (o = t, r(t));
        }
      };
    }, r)(t, e, o);
    return function () {
      n = !0, i(), o("-1");
    };
  }, [t, e, r]), n;
}

function Cr(_ref8) {
  var t = _ref8.ethereum,
      e = _ref8.pollBlockNumberInterval;
  var r = o(null),
      n = o(new Set()),
      c = i(function (t) {
    n.current.has(t) || (t(r.current), n.current.add(t));
  }, []),
      a = i(function (t) {
    n.current.delete(t);
  }, []),
      u = i(function (t) {
    r.current !== t && (r.current = t, n.current.forEach(function (e) {
      return e(t);
    }));
  }, []);
  return s(function () {
    if (!t) return void u(null);
    var r = !1;
    var n = er(function () {
      return {
        request: function request() {
          return function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(t) {
              return _regeneratorRuntime.wrap(function _callee8$(_context8) {
                while (1) {
                  switch (_context8.prev = _context8.next) {
                    case 0:
                      return _context8.abrupt("return", tr(t, "eth_blockNumber", []));

                    case 1:
                    case "end":
                      return _context8.stop();
                  }
                }
              }, _callee8);
            }));

            return function (_x8) {
              return _ref9.apply(this, arguments);
            };
          }()(t);
        },
        onResult: function onResult(t) {
          r || u(null === t ? null : qt.BigInt(t).toString());
        }
      };
    }, e)();
    return function () {
      r = !0, n();
    };
  }, [t, e, u]), {
    addBlockNumberListener: c,
    removeBlockNumberListener: a
  };
}

function Or(_ref10) {
  var n = _ref10.chainId,
      c = _ref10.children,
      h = _ref10.connectors,
      f = _ref10.pollBalanceInterval,
      d = _ref10.pollBlockNumberInterval;
  if (null !== r(br)) throw new Error("<UseWalletProvider /> has already been declared.");

  var _a14 = a(null),
      _a15 = _slicedToArray(_a14, 2),
      p = _a15[0],
      _ = _a15[1],
      _a16 = a(null),
      _a17 = _slicedToArray(_a16, 2),
      g = _a17[0],
      m = _a17[1],
      _a18 = a(null),
      _a19 = _slicedToArray(_a18, 2),
      v = _a19[0],
      y = _a19[1],
      _a20 = a("disconnected"),
      _a21 = _slicedToArray(_a20, 2),
      b = _a21[0],
      w = _a21[1],
      E = Ft(),
      C = o(0),
      O = E.account,
      P = E.library,
      N = Er({
    account: O,
    ethereum: P,
    pollBalanceInterval: f
  }),
      _Cr = Cr({
    ethereum: P,
    pollBlockNumberInterval: d
  }),
      I = _Cr.addBlockNumberListener,
      D = _Cr.removeBlockNumberListener,
      S = e(function () {
    return function (t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var _Object$entries$reduc = Object.entries(e).reduce(function (_ref11, _ref12) {
        var _ref13 = _slicedToArray(_ref11, 2),
            t = _ref13[0],
            e = _ref13[1];

        var _ref14 = _slicedToArray(_ref12, 2),
            r = _ref14[0],
            n = _ref14[1];

        return "function" == typeof n.web3ReactConnector ? [_objectSpread(_objectSpread({}, t), {}, _defineProperty({}, r, n)), e] : [t, [].concat(_toConsumableArray(e), [[r, n]])];
      }, [{}, []]),
          _Object$entries$reduc2 = _slicedToArray(_Object$entries$reduc, 2),
          r = _Object$entries$reduc2[0],
          n = _Object$entries$reduc2[1],
          o = _objectSpread({
        injected: {
          web3ReactConnector: function web3ReactConnector(_ref15) {
            var t = _ref15.chainId;
            return new We({
              supportedChainIds: [t]
            });
          },
          handleActivationError: function handleActivationError(t) {
            if (t instanceof qe) return new or();
          }
        },
        frame: {
          web3ReactConnector: function web3ReactConnector(_ref16) {
            var t = _ref16.chainId;
            return new Re({
              supportedChainIds: [t]
            });
          },
          handleActivationError: function handleActivationError(t) {
            return t instanceof Se ? new or() : t.message.startsWith("JSON.parse") ? new Error("There seems to be an issue when trying to connect to Frame.") : void 0;
          }
        },
        fortmatic: {
          web3ReactConnector: function web3ReactConnector(_ref17) {
            var t = _ref17.chainId,
                e = _ref17.apiKey;
            if (!e) throw new ir("The Fortmatic connector requires apiKey to be set.");
            return new Jt({
              apiKey: e,
              chainId: t
            });
          }
        },
        portis: {
          web3ReactConnector: function web3ReactConnector(_ref18) {
            var t = _ref18.chainId,
                e = _ref18.dAppId;
            if (!e) throw new ir("The Portis connector requires dAppId to be set.");
            return new Ge({
              dAppId: e,
              networks: [t]
            });
          }
        },
        provided: {
          web3ReactConnector: function web3ReactConnector(_ref19) {
            var t = _ref19.chainId,
                e = _ref19.provider;
            return new u({
              provider: e,
              supportedChainIds: [t]
            });
          },
          handleActivationError: function handleActivationError(t) {
            if (t instanceof l) return new or();
          }
        },
        authereum: {
          web3ReactConnector: function web3ReactConnector(_ref20) {
            var t = _ref20.chainId;
            return new Gt({
              chainId: t
            });
          }
        },
        squarelink: {
          web3ReactConnector: function web3ReactConnector(_ref21) {
            var t = _ref21.chainId,
                e = _ref21.clientId,
                r = _ref21.options;
            return new Je({
              clientId: e,
              networks: [t],
              options: r
            });
          }
        },
        torus: {
          web3ReactConnector: function web3ReactConnector(_ref22) {
            var t = _ref22.chainId,
                e = _ref22.initOptions,
                r = _ref22.constructorOptions;
            return new yr({
              chainId: t,
              constructorOptions: r,
              initOptions: e
            });
          }
        },
        walletconnect: {
          web3ReactConnector: function web3ReactConnector(_ref23) {
            var t = _ref23.chainId,
                e = _ref23.rpcUrl,
                r = _ref23.bridge,
                n = _ref23.pollingInterval;
            if (!e) throw new ir("The WalletConnect connector requires rpcUrl to be set.");
            if (!/^https?:\/\//.test(e)) throw new ir("The WalletConnect connector requires rpcUrl to be an HTTP URL.");
            return new vr({
              bridge: r,
              pollingInterval: n,
              qrcode: !0,
              rpc: _defineProperty({}, t, e)
            });
          },
          handleActivationError: function handleActivationError(t) {
            if (t instanceof mr) return new or();
          }
        },
        walletlink: {
          web3ReactConnector: function web3ReactConnector(_ref24) {
            var t = _ref24.chainId,
                e = _ref24.url,
                r = _ref24.appName,
                n = _ref24.appLogoUrl;
            if (1 !== t) throw new ir("The WalletLink connector requires chainId to be 1.");
            if (!/^https?:\/\//.test(e)) throw new ir("The WalletLink connector requires url to be an HTTP URL.");
            return new Xe({
              url: e,
              appName: r,
              appLogoUrl: n
            });
          }
        }
      }, r);

      var _iterator2 = _createForOfIteratorHelper(n),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _step2$value = _slicedToArray(_step2.value, 2),
              _t26 = _step2$value[0],
              _e36 = _step2$value[1];

          o[_t26] && (o[_t26].config = _e36);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return o;
    }(0, h);
  }, [n, h]),
      R = i(function () {
    E.active && E.deactivate(), _(null), m(null), w("disconnected");
  }, [E]),
      A = i( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
    var t,
        e,
        r,
        o,
        _e37,
        _args9 = arguments;

    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            t = _args9.length > 0 && _args9[0] !== undefined ? _args9[0] : "injected";
            e = ++C.current;

            if (!(R(), e !== C.current)) {
              _context9.next = 4;
              break;
            }

            return _context9.abrupt("return");

          case 4:
            if (S[t]) {
              _context9.next = 6;
              break;
            }

            return _context9.abrupt("return", (w("error"), void m(new nr(t))));

          case 6:
            w("connecting");
            r = S[t], o = r && r.web3ReactConnector && r.web3ReactConnector(_objectSpread({
              chainId: n
            }, r.config || {}));

            if (o) {
              _context9.next = 10;
              break;
            }

            return _context9.abrupt("return", (w("error"), void m(new nr(t))));

          case 10:
            _context9.prev = 10;

            _(t);

            _context9.next = 14;
            return E.activate(o, null, !0);

          case 14:
            w("connected");
            _context9.next = 28;
            break;

          case 17:
            _context9.prev = 17;
            _context9.t0 = _context9["catch"](10);

            if (!(e !== C.current)) {
              _context9.next = 21;
              break;
            }

            return _context9.abrupt("return");

          case 21:
            if (!(_(null), w("error"), _context9.t0 instanceof Bt)) {
              _context9.next = 23;
              break;
            }

            return _context9.abrupt("return", void m(new rr(-1, n)));

          case 23:
            if (!r.handleActivationError) {
              _context9.next = 27;
              break;
            }

            _e37 = r.handleActivationError(_context9.t0);

            if (!_e37) {
              _context9.next = 27;
              break;
            }

            return _context9.abrupt("return", void m(_e37));

          case 27:
            m(_context9.t0);

          case 28:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9, null, [[10, 17]]);
  })), [n, S, R, E]);

  s(function () {
    if (!O || !P) return;
    var t = !1;
    return y(null), function () {
      var _ref26 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(t, e) {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;
                _context10.next = 3;
                return tr(t, "eth_getCode", [e]);

              case 3:
                _context10.t0 = _context10.sent;
                return _context10.abrupt("return", "0x" !== _context10.t0);

              case 7:
                _context10.prev = 7;
                _context10.t1 = _context10["catch"](0);
                return _context10.abrupt("return", !1);

              case 10:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, null, [[0, 7]]);
      }));

      return function (_x9, _x10) {
        return _ref26.apply(this, arguments);
      };
    }()(P, O).then(function (e) {
      t || (w("connected"), y(e ? "contract" : "normal"));
    }), function () {
      t = !0, w("disconnected"), y(null);
    };
  }, [O, P]);
  var k = e(function () {
    return {
      _web3ReactContext: E,
      account: O || null,
      balance: N,
      chainId: n,
      connect: A,
      connector: p,
      connectors: S,
      error: g,
      ethereum: P,
      networkName: Qe(n),
      reset: R,
      status: b,
      type: v
    };
  }, [O, N, n, A, p, S, g, P, v, R, b, E]);
  return t.createElement(br.Provider, {
    value: {
      addBlockNumberListener: I,
      pollBalanceInterval: f,
      pollBlockNumberInterval: d,
      removeBlockNumberListener: D,
      wallet: k
    }
  }, c);
}

function Pr(e) {
  return t.createElement(Vt, {
    getLibrary: function getLibrary(t) {
      return t;
    }
  }, t.createElement(Or, e));
}

Or.propTypes = {
  chainId: ct.number,
  children: ct.node,
  connectors: ct.objectOf(ct.object),
  pollBalanceInterval: ct.number,
  pollBlockNumberInterval: ct.number
}, Or.defaultProps = {
  chainId: 1,
  connectors: {},
  pollBalanceInterval: 2e3,
  pollBlockNumberInterval: 5e3
}, Pr.propTypes = Or.propTypes, Pr.defaultProps = Or.defaultProps;
export { or as C, Pr as U, rr as a, nr as b, wr as c, g as d, _ as e, d as f, p as g, m as h, h as r, wr as u };